import "./styles.css";
import axios from "axios";
import { useEffect, useLayoutEffect, useState, useRef, useMemo, Alert } from "react";

import generalindex from "./jsons/index_general.json";
import timeline from "./jsons/timeline.json";
import index_items from "./jsons/index_items.json";
import index_mobs from "./jsons/index_mobs.json";
import index_maps from "./jsons/index_maps.json";

export const DEFAULT_EPISODE = "3"; // ← Change this to pre-load a different episode on startup

const droppedBy              = require(`./jsons/${DEFAULT_EPISODE}/dropped_by_${DEFAULT_EPISODE}.json`);
const items_default          = require(`./jsons/${DEFAULT_EPISODE}/item_db_${DEFAULT_EPISODE}.json`);
const item_descriptions_default = require(`./jsons/${DEFAULT_EPISODE}/item_description_${DEFAULT_EPISODE}.json`);
const mobs_default           = require(`./jsons/${DEFAULT_EPISODE}/mob_db_${DEFAULT_EPISODE}.json`);
const spawn_default          = require(`./jsons/${DEFAULT_EPISODE}/mob_spawn_${DEFAULT_EPISODE}.json`);


import mvps from "./jsons/mvps.json";
import minibosses from "./jsons/minibosses.json";
import elements from "./jsons/elements.json";
import wpn_dmg_per_size from "./jsons/wpn_dmg_per_size.json";
import mapManifest from "./jsons/map_manifest.json";
import worldmapData from "./jsons/worldmap.json";

import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import 'bootstrap/dist/css/bootstrap.min.css';

import EpisodeDetailsView from './components/EpisodeDetailsView.js';

export const DROP_SLOTS_ARRAY = [1,2,3,4,5,6,7,8,9];
export const MVP_DROP_SLOTS_ARRAY = [1,2,3];

// MENU STYLE SWITCHER - now driven by state (see useState below)

// LAYOUT PERCENTAGES - Manually adjust these to change container sizes (applies to both item and mob views)
const HEIGHT_RIGHT_TOP = "35%";              // Right container - Top section height
const WIDTH_RIGHT_BOTTOM_LEFT = "30%";       // Right container - Bottom left section width (Dropped By / Drop Table)
const WIDTH_RIGHT_BOTTOM_MID = "25%";        // Right container - Bottom middle section width (Card / Placeholder)
const WIDTH_RIGHT_BOTTOM_RIGHT = "45%";      // Right container - Bottom right section width (Maps)

const episodeContext = require.context('./jsons', true, /\/mob_db_[^/]+\.json$/);
export const AVAILABLE_EPISODES = new Set(episodeContext.keys().map(key => { const m = key.match(/^\.\/([^/]+)\//); return m ? m[1] : null; }).filter(Boolean));

const EPISODE_ORDER = ["default", "00", "0", "1", "1-5", "2", "3", "4", "5", "7", "10", "11", "12", "13-2"];

export const getMapUrl = (mapname, currentEpisode) => {
  const currentIdx = EPISODE_ORDER.indexOf(currentEpisode);
  // Check local deltas walking backward
  for (let i = currentIdx; i >= 0; i--) {
    const ep = EPISODE_ORDER[i];
    // Skip episode "00" if we're not in episode "00" (make 00 maps exclusive to episode 00)
    if (ep === "00" && currentEpisode !== "00") continue;
    if (mapManifest[ep] && mapManifest[ep][mapname]) {
      return `https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/maps/map_${ep}/${mapManifest[ep][mapname]}`;
    }
  }
  // Final fallback to default
  return `https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/maps/map_default/${mapname}.gif`;
};


export const DropEntry = ({
  dropID,
  dropRateMultiplier,
  baseDropRate,
  makeDropClickable,
  itemIndex,   // now coming from index_items
  currentEpisode,
  currentLanguage,
  slotNumber,
  isMvp,
  itemSlots
}) => {
  const getFormattedDropRate = () => {
    const minDropRate = dropRateMultiplier || 1;
    const formattedDropRate = parseFloat(((baseDropRate * minDropRate) / 100).toFixed(4));
    return formattedDropRate > 100 ? 100 : formattedDropRate;
  };

  return (
    <tr className={`title-${currentEpisode} link`} onClick={() => makeDropClickable(dropID)} style={{ cursor: "pointer", borderBottom: "1px solid #ddd" }}>
      <td style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey" }}>{slotNumber}</td>
      <td style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey" }}><img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/icons/${dropID}.png`} alt="" style={{ maxWidth: "24px", maxHeight: "24px", verticalAlign: "middle" }} /></td>
      <td style={{ textAlign: "left", padding: "4px 6px", whiteSpace: "nowrap", borderRight: "1px solid grey" }}>{ itemIndex[dropID] ? itemIndex[dropID][currentLanguage] : dropID }{Number(itemSlots) > 0 && <span style={{ opacity: 0.6 }}>{" "}[{itemSlots}]</span>}{isMvp && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/mvp.png" alt="MVP" style={{ maxHeight: "20px", marginLeft: "4px", verticalAlign: "middle" }} />}<span style={{ opacity: 0.6 }}>{" "}- {dropID}</span></td>
      <td style={{ textAlign: "center", padding: "4px 6px", whiteSpace: "nowrap" }}>{getFormattedDropRate()}%</td>
    </tr>
  );
};


export const RateInput = ({ value, onChange, style }) => {
  const [displayValue, setDisplayValue] = useState(value + "x");
  const inputRef = useRef(null);

  const handleChange = (e) => {
    let raw = e.target.value;
    raw = raw.replace(/[^0-9.,]/g, '');   // only allow digits, period, comma
    setDisplayValue(raw);
    const numeric = raw.replace(/,/g, '.');
    onChange(numeric);
  };

  const handleFocus = () => {
    let cleaned = displayValue.replace(/[xX]/g, '');
    setDisplayValue(cleaned);
    setTimeout(() => { if (inputRef.current) inputRef.current.select(); }, 0);
  };

  const handleBlur = () => {
    let cleaned = displayValue.replace(/[xX]/g, '');
    if (cleaned === '') cleaned = '1';
    setDisplayValue(cleaned + "x");
    const numeric = cleaned.replace(/,/g, '.');
    onChange(numeric);
  };

  return (
    <input
      ref={inputRef}
      style={style}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};


const formatSpawnDelay = (ms) => {
    if (!ms || ms <= 0) return "";
    const totalMin = Math.round(ms / 1000 / 60);
    if (totalMin < 60) return totalMin + "m";
    const hours = Math.floor(totalMin / 60);
    const mins = totalMin % 60;
    return mins > 0 ? hours + "h" + mins + "m" : hours + "h";
};

export const ItemMapsTabs = ({ itemID, currentEpisodeDroppedBy, currentEpisodeMobSpawn, activeItemMapTab, setactiveItemMapTab, currentEpisode, currentLanguage, onMobClick, getMapUrl, MENU_STYLE_CLASS }) => {
    const navScrollRef = useRef(null);
    const [canScrollLeft, setcanScrollLeft] = useState(false);
    const [canScrollRight, setcanScrollRight] = useState(false);

    const updateScrollArrows = () => {
        const el = navScrollRef.current;
        if (!el) return;
        setcanScrollLeft(el.scrollLeft > 0);
        setcanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    useEffect(() => { updateScrollArrows(); }, []);

    const scrollTabs = (direction) => {
        const el = navScrollRef.current;
        if (!el) return;
        el.scrollBy({ left: direction * 150, behavior: 'smooth' });
        setTimeout(updateScrollArrows, 350);
    };

    const handleWheel = (e) => {
        const el = navScrollRef.current;
        if (!el) return;
        e.preventDefault();
        el.scrollLeft += e.deltaY;
        updateScrollArrows();
    };

    // Get mobs that drop this item
    const droppedByMobs = currentEpisodeDroppedBy[itemID] || [];
    if (droppedByMobs.length === 0) return <div>No monsters drop this item.</div>;
    const mobIDs = droppedByMobs.map(e => e.mob_id);

    // Find all spawn entries for these mobs
    const rawFilteredSpawns = currentEpisodeMobSpawn.filter((entry) => mobIDs.some(mobId => mobId == entry.mob_id)); /* FIX === HERE */
    if (rawFilteredSpawns.length === 0) return <div>Mobs that drop this item have no spawn locations.</div>;

    // Aggregate spawn quantities per map per mob
    const mapMobAggregated = {};
    rawFilteredSpawns.forEach(e => {
        const key = e.mapname + "|" + e.mob_id;
        const prev = mapMobAggregated[key];
        mapMobAggregated[key] = prev
            ? { ...e, quantity: Number(prev.quantity) + Number(e.quantity), "min-spawn-delay": Math.max(Number(prev["min-spawn-delay"] || 0), Number(e["min-spawn-delay"] || 0)), "max-spawn-delay": Math.max(Number(prev["max-spawn-delay"] || 0), Number(e["max-spawn-delay"] || 0)) }
            : { ...e, quantity: Number(e.quantity), "min-spawn-delay": Number(e["min-spawn-delay"] || 0), "max-spawn-delay": Number(e["max-spawn-delay"] || 0) };
    });

    // Calculate total mob quantity per map
    const mapQuantities = {};
    Object.values(mapMobAggregated).forEach(e => {
        mapQuantities[e.mapname] = (mapQuantities[e.mapname] || 0) + Number(e.quantity);
    });

    // Get unique maps and sort by total quantity
    const uniqueMaps = [...new Set(rawFilteredSpawns.map(e => e.mapname))];
    const sortedMaps = uniqueMaps.map(mapname => ({ mapname, quantity: mapQuantities[mapname] })).sort((a, b) => b.quantity - a.quantity);

    // Get all monsters in these maps for display
    const mapIDs = sortedMaps.map((entry) => entry.mapname);
    const rawAllMonstersInMaps = currentEpisodeMobSpawn.filter((entry) => mapIDs.includes(entry.mapname));
    const allMonstersAggregated = {};
    rawAllMonstersInMaps.forEach(e => { const key = e.mapname + "|" + e.mob_id; const prev = allMonstersAggregated[key]; allMonstersAggregated[key] = prev ? { ...e, quantity: Number(prev.quantity) + Number(e.quantity), "min-spawn-delay": Math.max(Number(prev["min-spawn-delay"] || 0), Number(e["min-spawn-delay"] || 0)), "max-spawn-delay": Math.max(Number(prev["max-spawn-delay"] || 0), Number(e["max-spawn-delay"] || 0)) } : { ...e, quantity: Number(e.quantity), "min-spawn-delay": Number(e["min-spawn-delay"] || 0), "max-spawn-delay": Number(e["max-spawn-delay"] || 0) }; });
    const allMonstersInMaps = Object.values(allMonstersAggregated);

    return (
        <div className="spawn-maps-container" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            {MENU_STYLE_CLASS !== "title-left-container-alt" && <div className={`title-${currentEpisode} title-big`}>Where to Farm</div>}
            <Tab.Container id="ItemMapsTable" activeKey={activeItemMapTab} onSelect={(k) => setactiveItemMapTab(k)}>
                <div style={{ display: 'flex', alignItems: 'center', minWidth: 0, overflow: 'hidden', background: 'transparent' }}>
                    {canScrollLeft && (
                        <div onClick={() => scrollTabs(-1)} style={{ cursor: 'pointer', padding: '4px 6px', fontSize: '16px', userSelect: 'none', flexShrink: 0 }}>&#9664;</div>
                    )}
                    <div ref={navScrollRef} className="spawn-tabs-scroll" onScroll={updateScrollArrows} onWheel={handleWheel} style={{ flex: 1, overflowX: 'auto', background: 'transparent' }}>
                        <Nav variant="tabs">
                            {sortedMaps.map((entry, index) => (
                                <Nav.Item key={entry.mapname}>
                                    <Nav.Link eventKey={index}>{entry.mapname} ({entry.quantity})</Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                    </div>
                    {canScrollRight && (
                        <div onClick={() => scrollTabs(1)} style={{ cursor: 'pointer', padding: '4px 6px', fontSize: '16px', userSelect: 'none', flexShrink: 0 }}>&#9654;</div>
                    )}
                </div>
                <Tab.Content style={{ flex: 1, minHeight: 0 }}>
                    {sortedMaps.map((entry, index) => (
                        <Tab.Pane key={index} eventKey={index} style={{ height: '100%' }}>
                          <div id="cebola" className="spawn-pane-row" style={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}>
                            <div style={{ height: '100%' }}>
                                <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={getMapUrl(entry.mapname, currentEpisode)} alt={entry.mapname} onError={(e) => { e.target.onerror = null; e.target.src = `https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/maps/map_default/${entry.mapname}.gif`; }} />
                            </div>
                            <div style={{ marginLeft: '0px', overflow: 'auto', height: '100%', flex: 1, minWidth: 0 }}>
                                <div style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '4px', marginTop: "20px", marginLeft:"20px" }}>{ index_maps[entry.mapname] && index_maps[entry.mapname][currentLanguage] ? index_maps[entry.mapname][currentLanguage] : entry.mapname }</div>
                                <ul>
                                    {allMonstersInMaps
                                        .filter((line) => line.mapname == entry.mapname) /* FIX === HERE */
                                        .sort((a, b) => b.quantity - a.quantity) // Sort by MobCount
                                        .map((line2, index2) => (
                                            <li key={index2} style={{ fontWeight: mobIDs.some(mobId => mobId == line2.mob_id) ? 'bold' : 'normal', color: mobIDs.some(mobId => mobId == line2.mob_id) ? 'red' : 'inherit' }}>  {/*  */}
                                                <span className="spawn-mob-link" onClick={() => onMobClick(line2.mob_id)} style={{ cursor: 'pointer' }}>{ index_mobs[line2.mob_id] ? index_mobs[line2.mob_id][currentLanguage] : line2.mob_id }</span> - {line2.quantity}{(line2["min-spawn-delay"] > 0 || line2["max-spawn-delay"] > 0) && <span style={{ opacity: 0.6, fontSize: "0.9em" }}>{" "}({line2["min-spawn-delay"] > 0 && line2["max-spawn-delay"] > 0 ? formatSpawnDelay(line2["min-spawn-delay"]) + "~" + formatSpawnDelay(line2["max-spawn-delay"]) : formatSpawnDelay(line2["min-spawn-delay"] || line2["max-spawn-delay"])})</span>}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                          </div>
                        </Tab.Pane>
                    ))}
                </Tab.Content>
            </Tab.Container>
        </div>
    );
};

export const SpawnMapsTabs = ({ ID, currentEpisodeMobSpawn, activeSpawnTab, setactiveSpawnTab, currentEpisode, currentLanguage, onMobClick, getMapUrl }) => {
    const navScrollRef = useRef(null);
    const [canScrollLeft, setcanScrollLeft] = useState(false);
    const [canScrollRight, setcanScrollRight] = useState(false);

    const updateScrollArrows = () => {
        const el = navScrollRef.current;
        if (!el) return;
        setcanScrollLeft(el.scrollLeft > 0);
        setcanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    useEffect(() => { updateScrollArrows(); }, []);

    const scrollTabs = (direction) => {
        const el = navScrollRef.current;
        if (!el) return;
        el.scrollBy({ left: direction * 150, behavior: 'smooth' });
        setTimeout(updateScrollArrows, 350);
    };

    const handleWheel = (e) => {
        const el = navScrollRef.current;
        if (!el) return;
        e.preventDefault();
        el.scrollLeft += e.deltaY;
        updateScrollArrows();
    };

    const rawFilteredMaps = currentEpisodeMobSpawn.filter((entry) => entry.mob_id == ID); /* FIX === HERE */
    if (rawFilteredMaps.length === 0) return null;
    // Aggregate duplicate map entries for the selected mob (same mob can have multiple spawn entries on one map)
    const filteredMapsObj = {};
    rawFilteredMaps.forEach(e => { filteredMapsObj[e.mapname] = (filteredMapsObj[e.mapname] || 0) + Number(e.quantity); });
    const filteredMaps = Object.entries(filteredMapsObj).map(([mapname, quantity]) => ({ mapname, quantity, mob_id: ID })).sort((a, b) => b.quantity - a.quantity);
    const mapIDs = filteredMaps.map((entry) => entry.mapname);
    // Aggregate duplicate mob entries per map (same mob can have multiple spawn entries on one map)
    const rawAllMonstersInMaps = currentEpisodeMobSpawn.filter((entry) => mapIDs.includes(entry.mapname));
    const allMonstersAggregated = {};
    rawAllMonstersInMaps.forEach(e => { const key = e.mapname + "|" + e.mob_id; const prev = allMonstersAggregated[key]; allMonstersAggregated[key] = prev ? { ...e, quantity: Number(prev.quantity) + Number(e.quantity), "min-spawn-delay": Math.max(Number(prev["min-spawn-delay"] || 0), Number(e["min-spawn-delay"] || 0)), "max-spawn-delay": Math.max(Number(prev["max-spawn-delay"] || 0), Number(e["max-spawn-delay"] || 0)) } : { ...e, quantity: Number(e.quantity), "min-spawn-delay": Number(e["min-spawn-delay"] || 0), "max-spawn-delay": Number(e["max-spawn-delay"] || 0) }; });
    const allMonstersInMaps = Object.values(allMonstersAggregated);

    return (
        <div className="spawn-maps-container" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            <Tab.Container id="SpawnMapsTable" activeKey={activeSpawnTab} onSelect={(k) => setactiveSpawnTab(k)}>
                <div style={{ display: 'flex', alignItems: 'center', minWidth: 0, overflow: 'hidden', background: 'transparent' }}>
                    {canScrollLeft && (
                        <div onClick={() => scrollTabs(-1)} style={{ cursor: 'pointer', padding: '4px 6px', fontSize: '16px', userSelect: 'none', flexShrink: 0 }}>&#9664;</div>
                    )}
                    <div ref={navScrollRef} className="spawn-tabs-scroll" onScroll={updateScrollArrows} onWheel={handleWheel} style={{ flex: 1, overflowX: 'auto', background: 'transparent' }}>
                        <Nav variant="tabs">
                            {filteredMaps.map((entry, index) => (
                                <Nav.Item key={entry.mob_id + entry.mapname}>
                                    <Nav.Link eventKey={index}>{entry.mapname} ({entry.quantity})</Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                    </div>
                    {canScrollRight && (
                        <div onClick={() => scrollTabs(1)} style={{ cursor: 'pointer', padding: '4px 6px', fontSize: '16px', userSelect: 'none', flexShrink: 0 }}>&#9654;</div>
                    )}
                </div>
                <Tab.Content style={{ flex: 1, minHeight: 0 }}>
                    {filteredMaps.map((entry, index) => (
                        <Tab.Pane key={index} eventKey={index} style={{ height: '100%' }}>
                          <div id="cebola" className="spawn-pane-row" style={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}>
                            <div style={{ height: '100%' }}>
                                <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={getMapUrl(entry.mapname, currentEpisode)} alt={entry.mapname} onError={(e) => { e.target.onerror = null; e.target.src = `https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/maps/map_default/${entry.mapname}.gif`; }} />
                            </div>
                            <div style={{ marginLeft: '0px', overflow: 'auto', height: '100%', flex: 1, minWidth: 0 }}>
                                <div style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '4px', marginTop: "20px", marginLeft:"20px" }}>{ index_maps[entry.mapname] && index_maps[entry.mapname][currentLanguage] ? index_maps[entry.mapname][currentLanguage] : entry.mapname }</div>
                                <ul>
                                    {allMonstersInMaps
                                        .filter((line) => line.mapname == entry.mapname) /* FIX === HERE */
                                        .sort((a, b) => b.quantity - a.quantity) // Sort by MobCount
                                        .map((line2, index2) => (
                                            <li key={index2} style={{ fontWeight: ID == line2.mob_id ? 'bold' : 'normal', color: ID == line2.mob_id ? 'red' : 'inherit' }}>  {/*  */}
                                                <span className="spawn-mob-link" onClick={() => onMobClick(line2.mob_id)} style={{ cursor: 'pointer' }}>{ index_mobs[line2.mob_id] ? index_mobs[line2.mob_id][currentLanguage] : line2.mob_id }</span> - {line2.quantity}{(line2["min-spawn-delay"] > 0 || line2["max-spawn-delay"] > 0) && <span style={{ opacity: 0.6, fontSize: "0.9em" }}>{" "}({line2["min-spawn-delay"] > 0 && line2["max-spawn-delay"] > 0 ? formatSpawnDelay(line2["min-spawn-delay"]) + "~" + formatSpawnDelay(line2["max-spawn-delay"]) : formatSpawnDelay(line2["min-spawn-delay"] || line2["max-spawn-delay"])})</span>}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                          </div>
                        </Tab.Pane>
                    ))}
                </Tab.Content>
            </Tab.Container>
        </div>
    );
};


/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/
/* MOB SHARED TABLES - stats / elemental damage / weapon damage per size */
/* Used by both desktop themes AND AppMobile (parity) */
/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/

export const MobStatsTables = ({ selectedMob, currentLanguage, currentEpisode, baseExpMultiplier, jobExpMultiplier }) => {
  const cellL = { padding: "3px 10px", borderBottom: "1px solid #ccc", borderRight: "1px solid grey", fontWeight: "bold", textAlign: "left", whiteSpace: "nowrap" };
  const cellR = { padding: "3px 10px", borderBottom: "1px solid #ccc", textAlign: "right", whiteSpace: "nowrap" };
  const head = { padding: "3px 10px", borderBottom: "2px solid grey", textAlign: "center", fontWeight: "bold", backgroundColor: "rgba(255,255,255,0.10)", letterSpacing: "0.06em" };
  const tbl = { borderCollapse: "collapse", border: "1px solid grey", fontSize: "12px", alignSelf: "flex-start" };
  const Row = ({ label, value }) => (
    <tr><td style={cellL}>{label}</td><td style={cellR}>{value}</td></tr>
  );
  return (
    <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
      <table style={tbl}><tbody>
        <tr><th colSpan={2} className={`title-${currentEpisode}`} style={head}>General</th></tr>
        <Row label="HP" value={selectedMob.HP} />
        <Row label={generalindex[currentLanguage].general.base_exp || "Base Exp"} value={selectedMob.EXP * baseExpMultiplier} />
        <Row label={generalindex[currentLanguage].general.job_exp || "Job Exp"} value={selectedMob.JEXP * jobExpMultiplier} />
        <Row label={generalindex[currentLanguage].general.size || "Size"} value={generalindex[currentLanguage].size[selectedMob.Size]} />
        <Row label={generalindex[currentLanguage].general.race || "Race"} value={generalindex[currentLanguage].race[selectedMob.Race]} />
        <Row label={generalindex[currentLanguage].general.element || "Property"} value={`${generalindex[currentLanguage].element[selectedMob.Element.charAt(1)]} ${selectedMob.Element.charAt(0) / 2}`} />
      </tbody></table>
      <table style={tbl}><tbody>
        <tr><th colSpan={2} className={`title-${currentEpisode}`} style={head}>Combat</th></tr>
        <Row label="Level" value={selectedMob.LV} />
        <Row label="MinAtk" value={selectedMob.MinAtk} />
        <Row label="MaxAtk" value={selectedMob.MaxAtk} />
        <Row label="DEF" value={selectedMob.DEF} />
      </tbody></table>
      <table style={tbl}><tbody>
        <tr><th colSpan={2} className={`title-${currentEpisode}`} style={head}>Attributes</th></tr>
        <Row label="STR" value={selectedMob.STR} />
        <Row label="AGI" value={selectedMob.AGI} />
        <Row label="VIT" value={selectedMob.VIT} />
        <Row label="INT" value={selectedMob.INT} />
        <Row label="DEX" value={selectedMob.DEX} />
        <Row label="LUK" value={selectedMob.LUK} />
      </tbody></table>
    </div>
  );
};

export const ElementDamageTable = ({ selectedMob, currentLanguage }) => {
  const elTypeIndex = parseInt(selectedMob.Element.charAt(1));
  const elLevel = parseInt(selectedMob.Element.charAt(0)) / 2;
  const elArrayIndex = elTypeIndex * 4 + (elLevel - 1);
  const elData = elements[elArrayIndex];
  if (!elData) return null;
  const attackElements = ["Normal", "Water", "Earth", "Fire", "Wind", "Poison", "Holy", "Dark", "Ghost", "Undead"];
  const elIndexMap = { "Normal": "0", "Water": "1", "Earth": "2", "Fire": "3", "Wind": "4", "Poison": "5", "Holy": "6", "Dark": "7", "Ghost": "8", "Undead": "9" };
  const elColor = { "Normal": "#aaaaaa", "Water": "#3377dd", "Earth": "#55bb77", "Fire": "#dd4422", "Wind": "#ddbb22", "Poison": "#9955bb", "Holy": "#ddbb22", "Dark": "#554477", "Ghost": "#7799bb", "Undead": "#666666" };
  const getColor = (val) => {
    if (val < 0) return "#ff4444";
    if (val === 0) return "#999999";
    if (val < 100) return "#cc8800";
    if (val === 100) return "inherit";
    return "#22aa22";
  };
  const leftHalf = attackElements.slice(0, 5);
  const rightHalf = attackElements.slice(5);
  const half = (els) => (
    <table style={{ borderCollapse: "collapse", border: "1px solid grey", fontSize: "12px", flex: "1 1 0" }}>
      <tbody>
        {els.map(el => {
          const val = parseInt(elData[el]);
          return (
            <tr key={el}>
              <td style={{ padding: "2px 6px", borderRight: "1px solid grey", borderBottom: "1px solid #ccc", fontWeight: "bold", textAlign: "left", whiteSpace: "nowrap", ...(val > 100 ? { backgroundColor: elColor[el], color: "#fff" } : {}) }}>
                {generalindex[currentLanguage].element[elIndexMap[el]] || el}
              </td>
              <td style={{ padding: "2px 6px", borderBottom: "1px solid #ccc", textAlign: "center", color: getColor(val), fontWeight: val !== 100 ? "bold" : "normal" }}>
                {val}%
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
  return (
    <div style={{ display: "flex", gap: "6px" }}>
      {half(leftHalf)}
      {half(rightHalf)}
    </div>
  );
};

export const WpnDmgPerSizeTable = ({ selectedMob }) => {
  /* Shows ONLY the damage column matching the current mob's size, split into two side-by-side halves */
  const SIZE_COLS = ["Small", "Medium", "Large"];
  const mobSizeCol = SIZE_COLS[parseInt(selectedMob.Size)] || "Medium";
  const getColor = (val) => {
    if (val < 0) return "#ff4444";
    if (val === 0) return "#999999";
    if (val < 100) return "#cc8800";
    if (val === 100) return "inherit";
    return "#22aa22";
  };
  const mid = Math.ceil(wpn_dmg_per_size.length / 2);
  const half = (rows) => (
    <table style={{ borderCollapse: "collapse", border: "1px solid grey", fontSize: "12px", flex: "1 1 0", alignSelf: "flex-start" }}>
      <tbody>
        {rows.map((row) => {
          const val = parseInt(row[mobSizeCol]);
          return (
            <tr key={row.Weapon}>
              <td style={{ padding: "2px 6px", borderRight: "1px solid grey", borderBottom: "1px solid #ccc", fontWeight: "bold", textAlign: "left" }}>{row.Weapon}</td>
              <td style={{ padding: "2px 6px", borderBottom: "1px solid #ccc", textAlign: "center", color: getColor(val), fontWeight: val !== 100 ? "bold" : "normal" }}>{val}%</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
  return (
    <div style={{ display: "flex", gap: "6px" }}>
      {half(wpn_dmg_per_size.slice(0, mid))}
      {half(wpn_dmg_per_size.slice(mid))}
    </div>
  );
};


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* FUNCTION APP() */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/
/* TIMELINE VIEW */
/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/

/* Fixed light palette (borrowed from memorial-bro) — the timeline does NOT follow the episode theme */
const TL_SURFACE = "#ffffff";
const TL_PAPER_EDGE = "#d8e0ec";
const TL_INK = "#1a2238";
const TL_INK_2 = "#3a4a68";
const TL_INK_MUTED = "#7888a0";
const TL_ACCENT = "#4a7ecb";
const TL_ACCENT_DEEP = "#2a5a9b";
const TL_GOLD_DEEP = "#7a6020";

const TL_MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/* Normalize one content name: drop quotes, the "EP x -"/"Chapter x -" prefix, parentheticals and trailing "?",
   so the same content matches across distributions (kRO "EP 5 - Juno" == bRO "Juno", "Kunlun (Conlon)" == "Kunlun") */
const tlNormalize = (part) => part.toLowerCase().replace(/"/g, "").replace(/^(ep|chapter)\s*[\d.~-]*\s*-?\s*/, "").replace(/\(.*?\)/g, "").replace(/\?/g, "").trim();

/* Canonical episode colors extracted from the google sheets bar fills — the "standard" color per episode.
   Keys are tlNormalize()d names. Conflicts resolved in distro order kRO > jRO > iRO > euRO > bRO.
   Black/uncolored bars in the sheet (late kRO/jRO years) are NOT listed — they fall back to the hash color.
   Extra keys cover abbreviations/spellings: niff, noghaltz, einbech, splendid and manuka, port malaya. */
const TL_EPISODE_COLOR_MAP = {
  "- port malaya": "#ffd966",
  "abertura iris": "#e6e600",
  "alpha": "#ea9999",
  "amatsu": "#c27ba0",
  "ash vacuum": "#3d85c6",
  "ayothaya": "#e06666",
  "beta 1": "#d9ead3",
  "beta 2": "#ffe599",
  "beta 2  / ebeta2 / obt 1": "#ffe599",
  "beta 2 part 2 / cbt 1": "#a2c4c9",
  "brasilis": "#93c47d",
  "cbt 2": "#6d9eeb",
  "defense of the ancient": "#00ffff",
  "dewata": "#ffe599",
  "eclage": "#d5a6bd",
  "einbech": "#764a1b",
  "einbroch": "#764a1b",
  "el dicastes": "#9fc5e8",
  "encounter with the unknown": "#38761d",
  "heritage": "#e06666",
  "hugel": "#f2d3bd",
  "iro official launch": "#e06666",
  "izlude": "#4a86e8",
  "juno": "#3d85c6",
  "komodo": "#ff00ff",
  "kunlun": "#c27ba0",
  "lighthalzen": "#00ffff",
  "loki server": "#d9ead3",
  "louyang": "#e06666",
  "lutie": "#ff0000",
  "malangdo": "#e06666",
  "moscovia": "#8e7cc3",
  "nameless island": "#999999",
  "niff": "#674ea7",
  "nifflheim": "#674ea7",
  "noghalt": "#01c2c2",
  "noghaltz": "#01c2c2",
  "obt 2": "#8e7cc3",
  "open beta": "#ffe599",
  "p2p": "#ffe599",
  "port malaya": "#ffd966",
  "rachel": "#e69138",
  "rebirth": "#d543ab",
  "renewal": "#d543ab",
  "rockridge": "#ffd966",
  "sakray beta2": "#d9ead3",
  "satan morroc": "#b45f06",
  "secret dungeons": "#b7b7b7",
  "splendid and manuka": "#38761d",
  "splendor and manuka": "#38761d",
  "start of an adventure": "#000000",
  "training grounds": "#666666",
  "turtle": "#e6e600",
  "turtle + woe": "#e6e600",
  "umbala": "#6aa84f",
  "veins": "#ff0000",
  "woe": "#e6e600",
};

/* Year header colors extracted from the google sheets year row (2015+ are all #fff2cc in the sheet) */
const TL_YEAR_COLORS = { 2000: "#f6b26b", 2001: "#b6d7a8", 2002: "#a4c2f4", 2003: "#d5a6bd", 2004: "#ffe599", 2005: "#f4cccc", 2006: "#b6d7a8", 2007: "#9fc5e8", 2008: "#f4cccc", 2009: "#ffe599", 2010: "#6aa84f", 2011: "#f9cb9c", 2012: "#d9ead3", 2013: "#fff2cc", 2014: "#c9daf8" };

/* Sheet color when the episode has one; otherwise a deterministic hue from a string hash */
const tlColorFor = (part) => {
  const key = tlNormalize(part);
  if (TL_EPISODE_COLOR_MAP[key]) return TL_EPISODE_COLOR_MAP[key];
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) % 100000;
  return `hsl(${h % 360}, 64%, 46%)`;
};

/* "Amatsu + Kunlun" -> [color(Amatsu), color(Kunlun)] -> rendered as a striped segment.
   Parentheticals are dropped BEFORE splitting so 'Turtle + WoE ("Kamejima + Siege")' stays two parts. */
const tlColorsFor = (name) => name.replace(/\(.*?\)/g, "").split(" + ").map(tlColorFor);

/* Episode number + name -> rendered label: ("2.5", "Turtle + WoE") -> "EP 2.5 - Turtle + WoE" */
const tlDisplayName = (e) => (e.episode ? "EP " + e.episode + " - " + e.name : e.name);

/* Month token -> month number: accepts numeric ("05") or name ("May"/"MAY"/"may"), 3+ letters */
const tlMonthNum = (tok) => {
  const n = parseInt(tok);
  if (!isNaN(n)) return n;
  const i = TL_MONTH_NAMES.findIndex((m) => m.toLowerCase() === String(tok).toLowerCase().slice(0, 3));
  return i === -1 ? 1 : i + 1;
};

/* "2003-05-02" or "2003-May-02" -> "02-May-2003" | "2004-09"/"2004-Sep" -> "Sep-2004" | "2026" -> "2026" */
const tlFormatDate = (date) => {
  const p = date.split("-");
  if (p.length === 3) return p[2] + "-" + TL_MONTH_NAMES[tlMonthNum(p[1]) - 1] + "-" + p[0];
  if (p.length === 2) return TL_MONTH_NAMES[tlMonthNum(p[1]) - 1] + "-" + p[0];
  return p[0];
};

/* Groundwork for the event boxes below the timeline — intentionally empty for now.
   Shape of each entry: { date: "2004-09-03", title: "Open Beta", desc: "short narrative text", type: "start" | "merge" | "end" } */
const TIMELINE_BOXES = [];

export function TimelineView() {
  /* Which entry group (marker + label + its outgoing segment) is hovered — grows as one unit */
  const [hoveredEntry, sethoveredEntry] = useState(null);
  const PX_PER_MONTH = 100; /* proportion matched to the google sheets screenshot */
  const PX_PER_YEAR = PX_PER_MONTH * 12;
  const START_YEAR = 2001;
  const END_YEAR = 2027;
  const LEFT_COL_WIDTH = 58; /* just enough for the widest distro name (euRO) */
  const ROW_HEIGHT = 104;
  const totalWidth = (END_YEAR - START_YEAR + 1) * PX_PER_YEAR;
  const years = [];
  for (let y = START_YEAR; y <= END_YEAR; y++) years.push(y);
  const distributions = [...new Set(timeline.map((e) => e.distribution))];

  /* "2003-05-02" | "2003-May-02" | "2003-05" | "2003-May" | "2003" -> x position in px */
  const xFor = (date) => {
    const p = date.split("-");
    const y = parseInt(p[0]);
    const m = p[1] ? tlMonthNum(p[1]) : 1;
    const d = p[2] ? parseInt(p[2]) : 1;
    return (y - START_YEAR) * PX_PER_YEAR + ((m - 1) + (d - 1) / 31) * PX_PER_MONTH;
  };

  return (
    <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", background: TL_SURFACE, border: `1px solid ${TL_PAPER_EDGE}`, borderRadius: "4px", overflow: "hidden", textAlign: "left", color: TL_INK, fontFamily: '-apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>

{/* // Scrollable board */}
      <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <div style={{ width: (LEFT_COL_WIDTH + totalWidth) + "px" }}>

{/* // Sticky header: years row + months row */}
          <div style={{ position: "sticky", top: 0, zIndex: 3 }}>
            <div style={{ display: "flex" }}>
              <div style={{ position: "sticky", left: 0, zIndex: 4, minWidth: LEFT_COL_WIDTH + "px", flexShrink: 0, background: TL_SURFACE }}></div>
              {years.map((y) => (
                <div key={y} style={{ minWidth: PX_PER_YEAR + "px", boxSizing: "border-box", flexShrink: 0, borderLeft: `3px solid ${TL_INK_2}`, background: (TL_YEAR_COLORS[y] || "#fff2cc"), fontWeight: "bold", fontSize: "20px", color: TL_INK, padding: "3px 0px 3px 0px" }}>
                  <span style={{ position: "sticky", left: (LEFT_COL_WIDTH + 8) + "px", display: "inline-block", paddingLeft: "8px" }}>{y}</span>
                </div>
              ))}
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ position: "sticky", left: 0, zIndex: 4, minWidth: LEFT_COL_WIDTH + "px", flexShrink: 0, background: TL_SURFACE, borderBottom: `1px solid ${TL_PAPER_EDGE}` }}></div>
              {years.map((y) => (
                <div key={y} style={{ display: "flex", flexShrink: 0 }}>
                  {TL_MONTH_NAMES.map((m, mi) => (
                    <div key={m} style={{ minWidth: PX_PER_MONTH + "px", boxSizing: "border-box", flexShrink: 0, borderLeft: (mi === 0 ? `3px solid ${TL_INK_2}` : "1px solid rgba(120,136,160,0.18)"), borderBottom: `1px solid ${TL_PAPER_EDGE}`, background: TL_SURFACE, fontSize: "10px", color: TL_INK, padding: "1px 0px 2px 4px" }}>{m}</div>
                  ))}
                </div>
              ))}
            </div>
          </div>

{/* // One row per distribution - frozen name column + canvas */}
          {distributions.map((dist) => {
            const LINE_Y = 56;
            const evs = timeline.filter((e) => e.distribution === dist && e.date).map((e) => ({ ...e, x: xFor(e.date) })).sort((a, b) => a.x - b.x);

            /* Episodes carry the line color forward; events are diamond markers that do not touch the line */
            const eps = evs.filter((e) => e.type !== "event");

            /* An end_date that stands alone (gap before the next episode) gets a filled circle + date label at the segment end */
            eps.forEach((e, i) => {
              if (!e.end_date) return;
              const endX = xFor(e.end_date);
              const nextX = i < eps.length - 1 ? eps[i + 1].x : Infinity;
              if (endX > e.x && endX < nextX) e.endX = endX;
            });

            /* Auto-accommodate labels: slots in priority order (above the line first, then below,
               then the outer above/below slots). A slot is free when the previous label in it ended
               before this label's left edge; when nothing is free, take the slot that frees up earliest.
               Start labels anchor left at the marker; end-date labels anchor RIGHT at the end circle.
               Label block = 16px name + 12px date = 28px. Line at y56, circles reach y46.5/65.5.
               Compact rows fit 3 slots: 18-46 above the circles, 67-95 below, 96-124 outer-below
               (rows auto-grow when the outer-below slot is used; an outer-above cannot fit) */
            const SLOT_TOPS = [18, 67, 96];
            const slotEnds = [-Infinity, -Infinity, -Infinity];
            const labelItems = [];
            evs.forEach((e) => {
              const w = 14 + Math.max(tlDisplayName(e).length * 7, (tlFormatDate(e.date).length + (e.notes ? 2 : 0)) * 5.2);
              labelItems.push({ e, kind: "start", left: e.x, width: w });
            });
            eps.forEach((e) => {
              if (e.endX === undefined) return;
              const w = 10 + tlFormatDate(e.end_date).length * 5.8;
              labelItems.push({ e, kind: "end", left: e.endX - w, width: w });
            });
            labelItems.sort((a, b) => a.left - b.left);
            labelItems.forEach((it) => {
              let slot = SLOT_TOPS.findIndex((t, s) => slotEnds[s] <= it.left);
              if (slot === -1) slot = slotEnds.indexOf(Math.min(...slotEnds));
              if (it.kind === "start") { it.e.top = SLOT_TOPS[slot]; }
              /* date-only end labels hug the line: bottom of the slot when above, top when below */
              else { it.e.endTop = (slot === 0) ? SLOT_TOPS[slot] + 15 : SLOT_TOPS[slot]; }
              slotEnds[slot] = it.left + it.width;
            });

            /* Row height hugs the content: the gap between the deepest label and the distro divider is halved */
            const deepest = Math.max(LINE_Y + 12, ...evs.map((e) => e.top + 28), ...eps.filter((e) => e.endTop !== undefined).map((e) => e.endTop + 13));
            const rowH = deepest >= ROW_HEIGHT ? deepest + 7 : Math.ceil(deepest + (ROW_HEIGHT - deepest) / 2);

            return (
            <div key={dist} style={{ display: "flex", position: "relative", height: rowH + "px", borderBottom: "1px solid #000000" }}>
              <div style={{ position: "sticky", left: 0, zIndex: 2, minWidth: LEFT_COL_WIDTH + "px", boxSizing: "border-box", flexShrink: 0, display: "flex", alignItems: "center", paddingLeft: "10px", fontWeight: 700, fontSize: "14px", color: TL_INK, background: TL_SURFACE, borderRight: `1px solid ${TL_PAPER_EDGE}` }}>{dist}</div>

{/* // Canvas: soft month gridlines + stronger year lines + events as points */}
              <div style={{ position: "relative", width: totalWidth + "px", flexShrink: 0, backgroundImage: `repeating-linear-gradient(to right, rgba(26,34,56,0.35) 0px, rgba(26,34,56,0.35) 2px, transparent 2px, transparent ${PX_PER_YEAR}px), repeating-linear-gradient(to right, rgba(120,136,160,0.08) 0px, rgba(120,136,160,0.08) 1px, transparent 1px, transparent ${PX_PER_MONTH}px)` }}>
                <>
{/* // Lifeline: colored segments between episodes (striped when the episode is "A + B").
     An episode with end_date ends its segment there — gap until the next episode begins. */}
                      <svg width={totalWidth} height={rowH} style={{ position: "absolute", left: 0, top: 0 }}>
                        {eps.map((e, i) => {
                          const segEnd = e.end_date ? xFor(e.end_date) : (i < eps.length - 1 ? eps[i + 1].x : null);
                          if (segEnd === null || segEnd <= e.x) return null;
                          const colors = tlColorsFor(e.name);
                          const STRIPE = 14;
                          const hoverKey = dist + "|" + e.date + "|" + e.name;
                          return (
                            <g key={"s" + i} className={"tl-seg" + (hoveredEntry === hoverKey ? " tl-hot" : "")} onMouseEnter={() => sethoveredEntry(hoverKey)} onMouseLeave={() => sethoveredEntry(null)}>
{/* invisible hit line as wide as the GROWN segment, so the hover area matches the grown footprint */}
                              <line x1={e.x} y1={LINE_Y} x2={segEnd} y2={LINE_Y} stroke="transparent" strokeWidth={12} pointerEvents="stroke" />
                              {colors.map((c, k) => (
                                <line key={k} x1={e.x} y1={LINE_Y} x2={segEnd} y2={LINE_Y} stroke={c} strokeWidth={8.4}
                                  strokeLinecap={colors.length > 1 ? "butt" : "round"}
                                  strokeDasharray={colors.length > 1 ? `${STRIPE} ${STRIPE * (colors.length - 1)}` : undefined}
                                  strokeDashoffset={colors.length > 1 ? -(k * STRIPE) : undefined} />
                              ))}
                            </g>
                          );
                        })}
                      </svg>
{/* // Markers + labels: one hover group per entry — hovering the marker OR the name/date grows both together.
     Circle = episode (white fill, colored ring). Diamond = event (filled with its color). */}
                      {evs.map((e, i) => {
                        const hoverKey = dist + "|" + e.date + "|" + e.name;
                        return (
                        <div key={i} className={"tl-event" + (hoveredEntry === hoverKey ? " tl-hot" : "")} style={{ position: "absolute", left: e.x + "px", top: 0, height: "100%", pointerEvents: "none" }}>
                          {(e.type === "event")
                            ? <div className="tl-marker-diamond" title={e.notes || undefined} onMouseEnter={() => sethoveredEntry(hoverKey)} onMouseLeave={() => sethoveredEntry(null)} style={{ position: "absolute", left: "-7px", top: (LINE_Y - 7) + "px", width: "14px", height: "14px", background: tlColorsFor(e.name)[0], pointerEvents: "auto" }}></div>
                            : <div className="tl-marker-circle" title={e.notes || undefined} onMouseEnter={() => sethoveredEntry(hoverKey)} onMouseLeave={() => sethoveredEntry(null)} style={{ position: "absolute", left: "-9.5px", top: (LINE_Y - 9.5) + "px", width: "19px", height: "19px", borderRadius: "50%", boxSizing: "border-box", background: TL_SURFACE, border: `4px solid ${tlColorsFor(e.name)[0]}`, pointerEvents: "auto" }}></div>}
                          {e.endX !== undefined && (
                            <div className="tl-marker-circle-end" title={"End: " + tlFormatDate(e.end_date)} onMouseEnter={() => sethoveredEntry(hoverKey)} onMouseLeave={() => sethoveredEntry(null)} style={{ position: "absolute", left: (e.endX - e.x - 9.5) + "px", top: (LINE_Y - 9.5) + "px", width: "19px", height: "19px", borderRadius: "50%", boxSizing: "border-box", background: "#000000", border: `4px solid ${tlColorsFor(e.name)[0]}`, pointerEvents: "auto" }}></div>
                          )}
                          {e.endX !== undefined && e.endTop !== undefined && (
                            <div className="tl-label-end" onMouseEnter={() => sethoveredEntry(hoverKey)} onMouseLeave={() => sethoveredEntry(null)} style={{ position: "absolute", left: (e.endX - e.x - 2) + "px", top: e.endTop + "px", pointerEvents: "auto" }}>
                              <div style={{ whiteSpace: "nowrap", fontSize: "10px", lineHeight: "13px", color: TL_INK_MUTED }}>{tlFormatDate(e.end_date)}</div>
                            </div>
                          )}
                          <div className="tl-label" title={e.notes || undefined} onMouseEnter={() => sethoveredEntry(hoverKey)} onMouseLeave={() => sethoveredEntry(null)} style={{ position: "absolute", left: 0, top: e.top + "px", pointerEvents: "auto", whiteSpace: "nowrap" }}>
                            <div style={{ fontWeight: 700, fontSize: "13px", lineHeight: "16px", color: TL_INK }}>{tlDisplayName(e)}</div>
                            <div style={{ fontSize: "10px", lineHeight: "12px", color: TL_INK_MUTED }}>{tlFormatDate(e.date)}{e.notes ? " *" : ""}</div>
                          </div>
                        </div>
                        );
                      })}
                </>
              </div>
            </div>
            );
          })}

        </div>
      </div>

{/* // LEGEND */}
      <div style={{ flexShrink: 0, display: "flex", alignItems: "center", gap: "8px", padding: "6px 14px", borderTop: `1px solid ${TL_PAPER_EDGE}`, background: TL_SURFACE, fontSize: "11px", color: TL_INK_2 }}>
        <div style={{ width: "15px", height: "15px", borderRadius: "50%", boxSizing: "border-box", background: TL_SURFACE, border: `3px solid ${TL_ACCENT}`, flexShrink: 0 }}></div>
        <span>Episode / considered an episode in that distribution</span>
        <div style={{ width: "11px", height: "11px", background: TL_ACCENT, transform: "rotate(45deg)", marginLeft: "18px", flexShrink: 0 }}></div>
        <span>Event</span>
      </div>

{/* // EVENT BOXES - narrative cards below the board (structure ready, content comes later via TIMELINE_BOXES) */}
      <div style={{ flexShrink: 0, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "1px", background: TL_PAPER_EDGE, borderTop: `1px solid ${TL_PAPER_EDGE}` }}>
        {TIMELINE_BOXES.map((ev) => (
          <div key={ev.date + ev.title} style={{ background: TL_SURFACE, padding: "10px 12px" }}>
            <div style={{ fontSize: "9px", color: ev.type === "merge" ? TL_GOLD_DEEP : ev.type === "end" ? TL_INK_MUTED : TL_ACCENT_DEEP, marginBottom: "4px" }}>
              {ev.type === "merge" ? "◆" : ev.type === "end" ? "☾" : "▸"} {ev.date}
            </div>
            <div style={{ fontSize: "12px", fontWeight: 700, color: TL_INK, marginBottom: "2px" }}>{ev.title}</div>
            <div style={{ fontSize: "11px", color: TL_INK_2, lineHeight: 1.35 }}>{ev.desc}</div>
          </div>
        ))}
      </div>

    </div>
  );
}


/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/
/* WORLD MAP VIEW - interactive per-episode Midgard map */
/* Layout/underlay data: jsons/worldmap.json (built by scripts/worldmap_builder). */
/* Tiles come from the same getMapUrl pipeline as the spawn maps (S3, 512x512 native), */
/* so at max zoom (~12x of the 1000x815 canvas) each map shows at ~100% pixel size. */
/* Used by both desktop AND AppMobile (parity). */
/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/

/* Tint colors for the "Labels: episodes" overlay (RoCards-style episode coloring).
   Red family = beta/early, orange = Juno, greens = 6~8, blues = 10, purples = 11, teals = 12+ */
const WM_EP_COLORS = { "00": "#8e1b1b", "0": "#a93226", "1": "#c0392b", "1-5": "#d35452", "2": "#b03a5e", "3": "#a04000", "4": "#cb4335", "5": "#e67e22", "6": "#1e8449", "6-2": "#239b56", "7": "#27ae60", "7-1": "#2ecc71", "8-1": "#58d68d", "8-2": "#82e0aa", "10-1": "#2874a6", "10-2": "#2e86c1", "10-3": "#3498db", "10-4": "#5dade2", "11-1": "#6c3483", "11-2": "#7d3c98", "11-3": "#8e44ad", "12": "#117a65", "13-1": "#16a085", "13-2": "#45b39d" };

export function WorldMapView({ currentEpisode, currentLanguage, currentEpisodeMobSpawn, getMapUrl, onMobClick }) {
  const WM = worldmapData;
  /* Ep.00 (Alpha) is a different world entirely: own map set/layout/canvas, art from s3 map_00,
     red link lines instead of dungeon markers, no Midgard underlay */
  const isAlpha = currentEpisode === "00";
  const CANVAS_W = isAlpha ? WM.alpha.canvas.w : WM.canvas.w;
  const CANVAS_H = isAlpha ? WM.alpha.canvas.h : WM.canvas.h;
  const MAX_SCALE = 12;    /* ~43px layout rects * 12 = ~516px = native minimap size (the 1:1 zoom) */
  const MIN_SCALE = 0.3;

  const viewportRef = useRef(null);
  const dragRef = useRef({ pointers: new Map(), lastDist: null, moved: 0 });
  const [view, setview] = useState({ scale: 0.8, tx: 0, ty: 0 });
  const [showBorders, setshowBorders] = useState(false);     /* "Map shadow": the 1px outline drawn on each tile */
  const [showMapBorders, setshowMapBorders] = useState(false);/* "Map borders": the black frame baked into the gifs + the underlay's grid boxes; off (default) = crop tiles to content + grid-erased underlay */
  const [showUnderlay, setshowUnderlay] = useState(true);    /* the RoCards Midgard art behind the tiles */
  const [hoveredMap, sethoveredMap] = useState(null);
  const [popoverMap, setpopoverMap] = useState(null);        /* clicked map -> mob list popover */
  const [openDungeon, setopenDungeon] = useState(null);      /* clicked marker -> floor grid panel */
  const [labelMode, setlabelMode] = useState("none");        /* none | names | ids | episodes */
  const [dungeonLines, setdungeonLines] = useState(true);    /* true (default) = RoCards/emperium-style strips with red connector lines; false = numbered circles + floor table right of the world */
  const [stripAdjust, setstripAdjust] = useState({});        /* per-dungeon strip overrides while arranging: { id: { x, y, align } } */
  const stripDragRef = useRef(null);

  /* Fit the whole canvas in the viewport on mount and when the world changes size (alpha <-> midgard) */
  useLayoutEffect(() => {
    const el = viewportRef.current;
    if (!el) return;
    const s = Math.max(MIN_SCALE, Math.min(el.clientWidth / CANVAS_W, el.clientHeight / CANVAS_H) * 0.98);
    setview({ scale: s, tx: (el.clientWidth - CANVAS_W * s) / 2, ty: (el.clientHeight - CANVAS_H * s) / 2 });
  }, [isAlpha]);

  /* Which maps have spawns this episode (fields/dungeons visibility is spawn-driven) */
  const spawnMaps = useMemo(() => { const s = new Set(); currentEpisodeMobSpawn.forEach((e) => s.add(e.mapname)); return s; }, [currentEpisodeMobSpawn]);

  /* Towns are visible from their introduction episode onward (episodeTimeline order) */
  const epIdx = WM.episodeTimeline.indexOf(currentEpisode);
  const visibleMaps = useMemo(() => {
    if (isAlpha) return Object.entries(WM.alpha.world); /* the alpha layout IS the alpha world */
    return Object.entries(WM.world).filter(([name]) => {
      if (WM.towns[name] !== undefined) {
        if (epIdx === -1) return true;
        return WM.episodeTimeline.indexOf(WM.towns[name]) <= epIdx;
      }
      return spawnMaps.has(name);
    });
  }, [spawnMaps, epIdx, isAlpha]);

  /* A dungeon (marker + legend entry) exists when at least one of its floors has spawns */
  const visibleDungeons = useMemo(() => WM.dungeons.filter((d) => d.floors.some((f) => spawnMaps.has(f.map))), [spawnMaps]);

  const mapDisplayName = (m) => (index_maps[m] && index_maps[m][currentLanguage]) ? index_maps[m][currentLanguage] : m;
  const dungeonDisplayName = (d) => d.name[currentLanguage] ? d.name[currentLanguage] : d.name["en-us"];

  /* Zoom keeping the point under the cursor fixed */
  const zoomAt = (cx, cy, factor) => {
    setview((v) => {
      const s = Math.max(MIN_SCALE, Math.min(MAX_SCALE, v.scale * factor));
      if (s === v.scale) return v;
      return { scale: s, tx: cx - (cx - v.tx) * (s / v.scale), ty: cy - (cy - v.ty) * (s / v.scale) };
    });
  };

  /* Native wheel listener: React's synthetic wheel is passive, so preventDefault (page zoom/scroll) needs this */
  useEffect(() => {
    const el = viewportRef.current;
    if (!el) return;
    const onWheel = (e) => {
      e.preventDefault();
      const r = el.getBoundingClientRect();
      zoomAt(e.clientX - r.left, e.clientY - r.top, Math.exp(-e.deltaY * 0.0015));
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, []);

  /* Drag to pan + two-finger pinch (pointer events cover mouse and touch) */
  const onPointerDown = (e) => {
    const d = dragRef.current;
    d.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (d.pointers.size === 1) d.moved = 0;
    d.lastDist = null;
    /* NO setPointerCapture here: capturing on pointerdown retargets the click event to the
       viewport, so tiles/markers never receive onClick. Capture starts after real movement. */
  };
  const onPointerMove = (e) => {
    const d = dragRef.current;
    const prev = d.pointers.get(e.pointerId);
    if (!prev) return;
    d.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (d.pointers.size === 1) {
      const dx = e.clientX - prev.x, dy = e.clientY - prev.y;
      d.moved += Math.abs(dx) + Math.abs(dy);
      if (d.moved > 6 && !e.currentTarget.hasPointerCapture(e.pointerId)) e.currentTarget.setPointerCapture(e.pointerId);
      setview((v) => ({ ...v, tx: v.tx + dx, ty: v.ty + dy }));
    } else if (d.pointers.size === 2) {
      const pts = [...d.pointers.values()];
      const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
      const r = viewportRef.current.getBoundingClientRect();
      const midX = (pts[0].x + pts[1].x) / 2 - r.left, midY = (pts[0].y + pts[1].y) / 2 - r.top;
      if (d.lastDist) { d.moved += 10; zoomAt(midX, midY, dist / d.lastDist); }
      d.lastDist = dist;
    }
  };
  const onPointerUp = (e) => {
    const d = dragRef.current;
    d.pointers.delete(e.pointerId);
    d.lastDist = null;
  };
  /* Tiles/markers fire onClick after pointerup — swallow it when the gesture was a drag, not a click */
  const wasDrag = () => dragRef.current.moved > 6;

  /* Mob list for the clicked map, aggregated like SpawnMapsTabs (same mob can have several spawn lines) */
  const popoverMobs = useMemo(() => {
    if (popoverMap === null) return [];
    const agg = {};
    currentEpisodeMobSpawn.filter((e) => e.mapname === popoverMap).forEach((e) => { agg[e.mob_id] = (agg[e.mob_id] || 0) + Number(e.quantity); });
    return Object.entries(agg).map(([mob_id, quantity]) => ({ mob_id, quantity })).sort((a, b) => b.quantity - a.quantity);
  }, [popoverMap, currentEpisodeMobSpawn]);

  const openDungeonData = openDungeon !== null ? WM.dungeons.find((d) => d.id === openDungeon) : null;

  /* Screen-constant sizes inside the scaled canvas (divide by scale so zoom doesn't fatten them) */
  const px = (n) => n / view.scale;

  /* Episode overlay: one big label per intro-episode group, at the group's tile centroid */
  const epGroups = useMemo(() => {
    if (labelMode !== "episodes") return [];
    const g = {};
    visibleMaps.forEach(([name, r]) => {
      const ep = WM.intro[name];
      if (!ep) return;
      if (!g[ep]) g[ep] = { n: 0, x: 0, y: 0 };
      g[ep].n++; g[ep].x += r.x + r.w / 2; g[ep].y += r.y + r.h / 2;
    });
    return Object.entries(g).map(([ep, v]) => ({ ep, x: v.x / v.n, y: v.y / v.n }));
  }, [visibleMaps, labelMode]);

  /* Dungeon lines mode strip layout - used both as the default placement AND by Quick sort.
     Everything goes to the side its entrance is on (left entrances -> left margin, title right;
     right entrances -> right margin, title left). Each column is stacked in entrance order with
     every strip centered on its entrance's latitude, pushed apart only where crowded - the
     column may extend above/below the map (more canvas is fine). Lines stay short and, being
     sorted by latitude on both ends, same-side lines don't cross. Cheap greedy pass. */
  const computeStripLayout = () => {
    const GAP = 14, PAD = 70;
    const dims = (d) => { const cols = Math.min(d.floors.length, 8); const rows = Math.ceil(d.floors.length / 8); return { w: cols * 52 - 5, h: rows * 52 + 12 }; };
    const withMarker = visibleDungeons.filter((d) => d.marker);
    /* start each dungeon at the band of its NEAREST map edge (shortest possible line) */
    const assign = {};
    withMarker.forEach((d) => {
      const dl = d.marker.x, dr = CANVAS_W - d.marker.x, dt = d.marker.y, db = CANVAS_H - d.marker.y;
      const min = Math.min(dl, dr, dt, db);
      assign[d.id] = min === dl ? "left" : min === dr ? "right" : min === dt ? "top" : "bottom";
    });
    const pack = () => {
      const out = [];
      ["left", "right"].forEach((side) => {
        const list = withMarker.filter((d) => assign[d.id] === side).sort((a, b) => a.marker.y - b.marker.y);
        let prevBottom = -Infinity;
        const col = [];
        list.forEach((d) => {
          const { w, h } = dims(d);
          const desired = d.marker.y - h / 2;
          const y = Math.max(desired, prevBottom + GAP);
          prevBottom = y + h;
          col.push({ d, side, w, h, x: side === "left" ? -PAD - w : CANVAS_W + PAD, y, desired });
        });
        /* crowding only ever pushes one way - shift the pack back by half the average
           displacement so it re-centers on the map and the lines stay short */
        const shift = col.length ? col.reduce((sum, s) => sum + (s.y - s.desired), 0) / col.length / 2 : 0;
        col.forEach((s) => { s.y -= shift; out.push(s); });
      });
      ["top", "bottom"].forEach((side) => {
        const list = withMarker.filter((d) => assign[d.id] === side).sort((a, b) => a.marker.x - b.marker.x);
        let prevRight = -Infinity;
        const row = [];
        list.forEach((d) => {
          const { w, h } = dims(d);
          /* the left-aligned title sits above the tiles and is usually wider than a short strip -
             space slots by whichever is wider so neighboring titles never pile up */
          const slotW = Math.max(w, dungeonDisplayName(d).length * 7 + 24);
          const desired = d.marker.x - w / 2;
          const x = Math.max(desired, prevRight + GAP);
          prevRight = x + slotW;
          row.push({ d, side, w, h, x, y: side === "top" ? -PAD - h : CANVAS_H + PAD, desired });
        });
        const shift = row.length ? row.reduce((sum, s) => sum + (s.x - s.desired), 0) / row.length / 2 : 0;
        row.forEach((s) => { s.x -= shift; out.push(s); });
      });
      return out;
    };
    /* near-strict no-crossing rule: lines run marker -> first floor tile; each dungeon tries the
       other bands and keeps any move that lowers total crossings (then total line length).
       ~30 dungeons x 3 bands x 2 passes = instant. */
    const lineOf = (s) => {
      const al = s.side === "left" ? "right" : "left";
      const rows = Math.ceil(s.d.floors.length / 8);
      return { x1: s.d.marker.x, y1: s.d.marker.y,
               x2: al === "right" ? s.x + s.w - 23.5 : s.x + 23.5,
               y2: s.y + 17 + (al === "right" ? (rows - 1) * 52 : 0) + 23.5 };
    };
    const orient = (ax, ay, bx, by, cx, cy) => Math.sign((bx - ax) * (cy - ay) - (by - ay) * (cx - ax));
    const linesCross = (p, q) => {
      const o1 = orient(p.x1, p.y1, p.x2, p.y2, q.x1, q.y1);
      const o2 = orient(p.x1, p.y1, p.x2, p.y2, q.x2, q.y2);
      const o3 = orient(q.x1, q.y1, q.x2, q.y2, p.x1, p.y1);
      const o4 = orient(q.x1, q.y1, q.x2, q.y2, p.x2, p.y2);
      return o1 !== o2 && o3 !== o4 && o1 !== 0 && o3 !== 0;
    };
    const score = (strips) => {
      const lines = strips.map(lineOf);
      let c = 0, len = 0;
      for (let i = 0; i < lines.length; i++) {
        len += Math.hypot(lines[i].x2 - lines[i].x1, lines[i].y2 - lines[i].y1);
        for (let j = i + 1; j < lines.length; j++) if (linesCross(lines[i], lines[j])) c++;
      }
      return { c, len };
    };
    let best = pack();
    let bestScore = score(best);
    for (let pass = 0; pass < 2 && bestScore.c > 0; pass++) {
      let improved = false;
      withMarker.forEach((d) => {
        ["left", "right", "top", "bottom"].forEach((band) => {
          if (band === assign[d.id]) return;
          const prev = assign[d.id];
          assign[d.id] = band;
          const cand = pack();
          const sc = score(cand);
          if (sc.c < bestScore.c || (sc.c === bestScore.c && sc.len < bestScore.len - 1)) {
            best = cand; bestScore = sc; improved = true;
          } else {
            assign[d.id] = prev;
          }
        });
      });
      if (!improved) break;
    }
    return best;
  };

  const dungeonStrips = useMemo(() => {
    if (!dungeonLines) return [];
    return computeStripLayout();
  }, [visibleDungeons, dungeonLines]);

  /* Circles mode: floor-depth table right of the world (B5..B1 | 1..N columns, one row per dungeon;
     free-grid complexes like Glast Heim get their own wrapped blocks below the table) */
  const TBL_X = CANVAS_W + 70, TBL_NAME_W = 175, TBL_PITCH = 52, TBL_ROW_H = 58;
  const tableDungeons = visibleDungeons.filter((d) => d.floors.some((f) => f.depth !== null));
  const freeDungeons = visibleDungeons.filter((d) => d.floors.length > 0 && d.floors.every((f) => f.depth === null));
  const tableDepths = (() => { const s = new Set(); tableDungeons.forEach((d) => d.floors.forEach((f) => { if (f.depth !== null) s.add(f.depth); })); return [...s].sort((a, b) => a - b); })();
  const depthCol = (dep) => tableDepths.indexOf(dep);
  const depthLabel = (dep) => (dep < 0 ? "B" + (-dep) : String(dep));
  let freeY = 58 + tableDungeons.length * TBL_ROW_H + 28;
  const freeBlocks = freeDungeons.map((d) => { const rows = Math.ceil(d.floors.length / 8); const b = { d, y: freeY }; freeY += rows * 52 + 36; return b; });

  /* Strip position/alignment: live drag override > baked default from dungeons_def > auto placement.
     "Copy dungeon layout" exports the effective values so a hand-arranged view can become the baked default. */
  const stripPos = (s) => {
    const adj = stripAdjust[s.d.id];
    const baked = s.d.strip;
    return {
      x: adj && adj.x !== undefined ? adj.x : (baked && baked.x !== undefined ? baked.x : s.x),
      y: adj && adj.y !== undefined ? adj.y : (baked && baked.y !== undefined ? baked.y : s.y),
    };
  };
  const stripAlign = (s) => {
    const adj = stripAdjust[s.d.id];
    if (adj && adj.align) return adj.align;
    if (s.d.strip && s.d.strip.align) return s.d.strip.align;
    return s.side === "left" ? "right" : "left"; /* title hugs the map-facing end by default */
  };

  /* Quick sort button: re-run the layout algorithm and make it override any dragged/baked
     positions (clears manual arranging back to the computed standard) */
  const quickSortStrips = () => {
    const next = {};
    computeStripLayout().forEach((s) => { next[s.d.id] = { x: s.x, y: s.y, align: s.side === "left" ? "right" : "left" }; });
    setstripAdjust(next);
  };

  /* One detached floor tile (used by the side table and the lines-mode strips) */
  const floorTile = (f) => {
    const hasSpawns = spawnMaps.has(f.map);
    return (
      <div key={f.map}
        onClick={(e) => { e.stopPropagation(); if (!wasDrag() && hasSpawns) { setopenDungeon(null); setpopoverMap((prev) => (prev === f.map ? null : f.map)); } }}
        onMouseEnter={() => sethoveredMap(f.map)}
        onMouseLeave={() => sethoveredMap((h) => (h === f.map ? null : h))}
        style={{ position: "relative", width: "47px", height: "47px", flexShrink: 0, cursor: hasSpawns ? "pointer" : "default", opacity: hasSpawns ? 1 : 0.35 }}>
        <img src={getMapUrl(f.map, currentEpisode)} alt={f.map} draggable={false}
          onError={(e) => { e.target.style.display = "none"; }}
          style={{ width: "100%", height: "100%", display: "block", boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.7)" }} />
        {hoveredMap === f.map && (
          <div style={{ position: "absolute", left: "50%", top: "100%", transform: "translateX(-50%)", marginTop: "2px", background: "rgba(0,0,0,0.85)", color: "#fff", fontSize: "10px", padding: "1px 5px", borderRadius: "3px", whiteSpace: "nowrap", pointerEvents: "none", zIndex: 9 }}>{mapDisplayName(f.map)}</div>
        )}
      </div>
    );
  };

  return (
    <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", textAlign: "left" }}>

{/* // Toolbar - toggles + dungeon legend + zoom */}
      <div className={`title-${currentEpisode}`} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "14px", padding: "6px 10px", flexShrink: 0 }}>
        <label style={{ cursor: "pointer", userSelect: "none" }}><input type="checkbox" checked={showBorders} onChange={() => setshowBorders(v => !v)} /> Map shadow</label>
        <label style={{ cursor: "pointer", userSelect: "none" }}><input type="checkbox" checked={showMapBorders} onChange={() => setshowMapBorders(v => !v)} /> Map borders</label>
        {!isAlpha && <label style={{ cursor: "pointer", userSelect: "none" }}><input type="checkbox" checked={showUnderlay} onChange={() => setshowUnderlay(v => !v)} /> Background</label>}
        {!isAlpha && <label style={{ cursor: "pointer", userSelect: "none" }}><input type="checkbox" checked={dungeonLines} onChange={() => setdungeonLines(v => !v)} /> Dungeon lines</label>}
        {!isAlpha && dungeonLines && (
          <button className={`title-${currentEpisode} nav-menu-button`} style={{ padding: "2px 10px" }} onClick={quickSortStrips}>Quick sort</button>
        )}
        {!isAlpha && dungeonLines && (
          <button className={`title-${currentEpisode} nav-menu-button`} style={{ padding: "2px 10px" }} onClick={() => {
            const layout = {};
            dungeonStrips.forEach((s) => { const p = stripPos(s); layout[s.d.id] = { x: Math.round(p.x), y: Math.round(p.y), align: stripAlign(s) }; });
            const txt = JSON.stringify(layout, null, 1);
            if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(txt); alert("Dungeon layout copied to clipboard - paste it to Claude to bake it in as the default view."); }
            else { console.log(txt); alert("Clipboard unavailable - layout printed to the browser console instead."); }
          }}>Copy dungeon layout</button>
        )}
        <select value={labelMode} onChange={(e) => setlabelMode(e.target.value)}>
          <option value="none">Labels: none</option>
          <option value="names">Labels: map names</option>
          <option value="ids">Labels: map IDs</option>
          <option value="episodes">Labels: episodes</option>
        </select>
        {!isAlpha && <select value={openDungeon === null ? "" : openDungeon} onChange={(e) => { setpopoverMap(null); setopenDungeon(e.target.value === "" ? null : e.target.value); }}>
          <option value="">Dungeons...</option>
          {visibleDungeons.map((d, i) => (
            <option key={d.id} value={d.id}>{(i + 1) + ". " + dungeonDisplayName(d)}</option>
          ))}
        </select>}
        <div style={{ marginLeft: "auto", display: "flex", gap: "6px" }}>
          <button className={`title-${currentEpisode} nav-menu-button`} style={{ padding: "2px 10px" }} onClick={() => { const el = viewportRef.current; if (el) zoomAt(el.clientWidth / 2, el.clientHeight / 2, 1.5); }}>+</button>
          <button className={`title-${currentEpisode} nav-menu-button`} style={{ padding: "2px 10px" }} onClick={() => { const el = viewportRef.current; if (el) zoomAt(el.clientWidth / 2, el.clientHeight / 2, 1 / 1.5); }}>−</button>
          <button className={`title-${currentEpisode} nav-menu-button`} style={{ padding: "2px 10px" }} onClick={() => { const el = viewportRef.current; if (!el) return; const s = Math.max(MIN_SCALE, Math.min(el.clientWidth / CANVAS_W, el.clientHeight / CANVAS_H) * 0.98); setview({ scale: s, tx: (el.clientWidth - CANVAS_W * s) / 2, ty: (el.clientHeight - CANVAS_H * s) / 2 }); }}>Fit</button>
        </div>
      </div>

{/* // Viewport - pan/zoom stage. touchAction none so mobile gestures reach the pointer handlers */}
      <div ref={viewportRef} style={{ flex: 1, minHeight: 0, position: "relative", overflow: "hidden", cursor: "grab", touchAction: "none", userSelect: "none" }}
        onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerUp} onPointerCancel={onPointerUp}
        onClick={() => { if (!wasDrag()) { setpopoverMap(null); setopenDungeon(null); } }}>

        <div style={{ position: "absolute", left: 0, top: 0, width: CANVAS_W + "px", height: CANVAS_H + "px", transform: `translate(${view.tx}px, ${view.ty}px) scale(${view.scale})`, transformOrigin: "0 0" }}>

{/* // Underlay - the seamless Midgard art (RoCards, chrome cleaned by scripts/worldmap_builder).
     Map borders off swaps to the grid-erased variant - the box outlines are burned into the art itself */}
          {showUnderlay && !isAlpha && (
            <img src={showMapBorders ? "/img/worldmap.jpg" : "/img/worldmap-nogrid.jpg"} alt="" draggable={false} style={{ position: "absolute", left: 0, top: 0, width: "100%", height: "100%", pointerEvents: "none" }} />
          )}

{/* // Alpha world: red connection lines between non-adjacent maps (drawn under the tiles,
     center to center - only the between-tiles segment shows), as in the old alpha map charts */}
          {isAlpha && (
            <svg style={{ position: "absolute", left: 0, top: 0, pointerEvents: "none", zIndex: 0 }} width={CANVAS_W} height={CANVAS_H} viewBox={`0 0 ${CANVAS_W} ${CANVAS_H}`}>
              {WM.alpha.links.map(([a, b]) => {
                const ra = WM.alpha.world[a], rb = WM.alpha.world[b];
                if (!ra || !rb) return null;
                return <line key={a + b} x1={ra.x + ra.w / 2} y1={ra.y + ra.h / 2} x2={rb.x + rb.w / 2} y2={rb.y + rb.h / 2} stroke="#d21f1f" strokeWidth="3.5" />;
              })}
            </svg>
          )}

{/* // Map tiles - hovered one enlarges; borders are screen-constant via 1/scale inset shadow */}
          {visibleMaps.map(([name, r]) => {
            /* Map borders off: crop the image to its content bbox (crop insets measured at build
               time per art folder - the episode override art can have a different frame than the
               default gif), so the black frame disappears and neighboring terrain touches */
            const tileUrl = isAlpha ? `https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/maps/map_00/${name}.gif` : getMapUrl(name, currentEpisode);
            const urlFolder = tileUrl.match(/\/map_([^/]+)\//);
            const cropSet = urlFolder && WM.crop[urlFolder[1]];
            const c = (!showMapBorders && cropSet && cropSet[name]) || null;
            const imgStyle = c
              ? { position: "absolute", width: (100 / (1 - c[0] - c[2])) + "%", height: (100 / (1 - c[1] - c[3])) + "%", left: (-c[0] * 100 / (1 - c[0] - c[2])) + "%", top: (-c[1] * 100 / (1 - c[1] - c[3])) + "%", display: "block" }
              : { width: "100%", height: "100%", display: "block" };
            /* Borders off: the RoCards rects leave a 1px gutter between neighbors - grow each tile
               half a pixel per side so adjacent terrain actually touches (overlap is invisible) */
            const g = showMapBorders ? 0 : 0.5;
            return (
            <div key={name}
              onMouseEnter={() => sethoveredMap(name)}
              onMouseLeave={() => sethoveredMap((h) => (h === name ? null : h))}
              onClick={(e) => { e.stopPropagation(); if (!wasDrag()) { setopenDungeon(null); setpopoverMap((prev) => (prev === name ? null : name)); } }}
              style={{ position: "absolute", left: (r.x - g) + "px", top: (r.y - g) + "px", width: (r.w + 2 * g) + "px", height: (r.h + 2 * g) + "px", cursor: "pointer",
                zIndex: hoveredMap === name ? 5 : (WM.raised && WM.raised.includes(name) ? 2 : 1), /* raised = floating maps (Juno) drawn above neighbors */
                transform: hoveredMap === name ? "scale(1.18)" : "none", transition: "transform 120ms",
                boxShadow: showBorders ? `inset 0 0 0 ${px(1)}px rgba(0,0,0,0.8)` : (hoveredMap === name ? `0 0 ${px(10)}px rgba(0,0,0,0.6)` : "none") }}>
              <div style={{ position: "absolute", inset: 0, overflow: "hidden" }}>
                <img src={tileUrl} alt={name} draggable={false}
                  onError={(e) => { e.target.style.display = "none"; }}
                  style={imgStyle} />
              </div>
              {labelMode === "episodes" && WM.intro[name] && (
                <div style={{ position: "absolute", inset: 0, background: WM_EP_COLORS[WM.intro[name]] || "#7f8c8d", opacity: 0.45, pointerEvents: "none" }} />
              )}
              {(labelMode === "names" || labelMode === "ids") && (
                <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", fontSize: labelMode === "ids" ? "7px" : "7.5px", lineHeight: "1.15", color: "#fff", textShadow: "0 0 2px #000, 0 1px 2px #000", padding: "2px", overflow: "hidden", pointerEvents: "none" }}>
                  {labelMode === "ids" ? name : mapDisplayName(name)}
                </div>
              )}
              {hoveredMap === name && (
                <div style={{ position: "absolute", left: "50%", top: "100%", transform: "translateX(-50%)", marginTop: px(3) + "px", background: "rgba(0,0,0,0.8)", color: "#fff", fontSize: px(12) + "px", padding: `${px(2)}px ${px(6)}px`, borderRadius: px(3) + "px", whiteSpace: "nowrap", pointerEvents: "none", zIndex: 6 }}>
                  {mapDisplayName(name)}
                </div>
              )}
            </div>
            );
          })}

{/* // Episode overlay group labels - one per intro episode, at the group's centroid */}
          {labelMode === "episodes" && epGroups.map((g) => (
            <div key={g.ep} style={{ position: "absolute", left: g.x + "px", top: g.y + "px", transform: "translate(-50%, -50%)", fontSize: "15px", fontWeight: "bold", color: "#fff", textShadow: "0 0 3px #000, 0 0 3px #000, 0 1px 4px #000", pointerEvents: "none", zIndex: 8, whiteSpace: "nowrap" }}>
              Ep. {g.ep.replace("-", ".")}
            </div>
          ))}

{/* // Dungeon entrance markers - pRO-poster style numbered red dots (circles mode only) */}
          {!dungeonLines && visibleDungeons.map((d, i) => d.marker && (
            <div key={d.id}
              onClick={(e) => { e.stopPropagation(); if (!wasDrag()) { setpopoverMap(null); setopenDungeon(d.id); } }}
              title={dungeonDisplayName(d)}
              style={{ position: "absolute", left: (d.marker.x - px(8)) + "px", top: (d.marker.y - px(8)) + "px", width: px(16) + "px", height: px(16) + "px", borderRadius: "50%",
                background: "#c81e1e", border: `${px(1.5)}px solid #fff`, boxShadow: `0 0 ${px(4)}px rgba(0,0,0,0.7)`, color: "#fff",
                fontSize: px(9) + "px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 7 }}>
              {i + 1}
            </div>
          ))}

{/* // Circles mode: dungeon floor-depth table right of the world (B5..B1 | 1..N), Glast Heim-style
     free complexes as wrapped blocks below it. Lives in canvas space so it pans/zooms with the map */}
          {!dungeonLines && tableDungeons.length > 0 && (
            <>
              <div style={{ position: "absolute", left: TBL_X + "px", top: "6px", fontSize: "18px", fontWeight: "bold", color: "#fff", textShadow: "0 0 3px #000" }}>Dungeons</div>
              {tableDepths.map((dep, ci) => (
                <div key={dep} style={{ position: "absolute", left: (TBL_X + TBL_NAME_W + ci * TBL_PITCH) + "px", top: "34px", width: "47px", textAlign: "center", fontSize: "14px", fontWeight: "bold", color: "#fff", textShadow: "0 0 3px #000" }}>{depthLabel(dep)}</div>
              ))}
              {tableDungeons.map((d, ri) => (
                <div key={d.id} style={{ position: "absolute", left: TBL_X + "px", top: (58 + ri * TBL_ROW_H) + "px", height: "47px" }}>
                  <div style={{ position: "absolute", left: 0, top: 0, width: TBL_NAME_W + "px", height: "100%", display: "flex", alignItems: "center", fontSize: "12px", fontWeight: "bold", color: "#fff", textShadow: "0 0 3px #000", paddingRight: "8px", boxSizing: "border-box" }}>{dungeonDisplayName(d)}</div>
                  {d.floors.filter((f) => f.depth !== null).map((f) => (
                    <div key={f.map} style={{ position: "absolute", left: (TBL_NAME_W + depthCol(f.depth) * TBL_PITCH) + "px", top: 0 }}>{floorTile(f)}</div>
                  ))}
                </div>
              ))}
              {freeBlocks.map(({ d, y }) => (
                <div key={d.id} style={{ position: "absolute", left: TBL_X + "px", top: y + "px", width: (TBL_NAME_W + tableDepths.length * TBL_PITCH) + "px" }}>
                  <div style={{ fontSize: "12px", fontWeight: "bold", color: "#fff", textShadow: "0 0 3px #000", marginBottom: "4px" }}>{dungeonDisplayName(d)}</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>{d.floors.map((f) => floorTile(f))}</div>
                </div>
              ))}
            </>
          )}

{/* // Lines mode: entrance dots + red connector lines to floor strips parked in the margins */}
          {dungeonLines && (
            <>
              <svg style={{ position: "absolute", left: "-900px", top: "-500px", pointerEvents: "none", zIndex: 8 }} width="3000" height="2200" viewBox="-900 -500 3000 2200">
                {dungeonStrips.map((s) => {
                  /* the line always points at the FIRST floor of the dungeon: with a right-aligned
                     title the floor order is reversed, so floor 1 is the right-most tile */
                  const p = stripPos(s);
                  const al = stripAlign(s);
                  const rows = Math.ceil(s.d.floors.length / 8);
                  const ex = al === "right" ? p.x + s.w - 23.5 : p.x + 23.5;
                  const ey = p.y + 17 + (al === "right" ? (rows - 1) * 52 : 0) + 23.5;
                  return <line key={s.d.id} x1={s.d.marker.x} y1={s.d.marker.y} x2={ex} y2={ey} stroke="#d21f1f" strokeWidth={px(2.5)} opacity="0.85" />;
                })}
              </svg>
              {dungeonStrips.map((s) => (
                <div key={s.d.id} style={{ position: "absolute", left: (s.d.marker.x - px(4)) + "px", top: (s.d.marker.y - px(4)) + "px", width: px(8) + "px", height: px(8) + "px", borderRadius: "50%", background: "#d21f1f", border: `${px(1)}px solid #fff`, zIndex: 7 }} />
              ))}
{/* // Strips are draggable as a whole (title + maps): arrange them, then "Copy dungeon layout" to bake in.
     The small arrows toggle whether the title hugs the left-most or right-most map */}
              {dungeonStrips.map((s) => {
                const p = stripPos(s);
                const al = stripAlign(s);
                return (
                <div key={s.d.id + "-strip"}
                  onPointerDown={(e) => { e.stopPropagation(); dragRef.current.moved = 0; stripDragRef.current = { id: s.d.id, px: e.clientX, py: e.clientY, x: p.x, y: p.y }; }}
                  onPointerMove={(e) => {
                    const sd = stripDragRef.current;
                    if (!sd || sd.id !== s.d.id) return;
                    const dx = e.clientX - sd.px, dy = e.clientY - sd.py;
                    dragRef.current.moved += Math.abs(dx) + Math.abs(dy);
                    if (dragRef.current.moved > 6 && !e.currentTarget.hasPointerCapture(e.pointerId)) e.currentTarget.setPointerCapture(e.pointerId);
                    sd.x += dx / view.scale; sd.y += dy / view.scale; sd.px = e.clientX; sd.py = e.clientY;
                    const id = sd.id, nx = sd.x, ny = sd.y;
                    setstripAdjust((prev) => ({ ...prev, [id]: { ...prev[id], x: nx, y: ny } }));
                  }}
                  onPointerUp={() => { stripDragRef.current = null; }}
                  onClick={(e) => e.stopPropagation()}
                  style={{ position: "absolute", left: p.x + "px", top: p.y + "px", width: s.w + "px", paddingTop: "17px", cursor: "grab", zIndex: 6 }}>
{/* // Title is edge-anchored: right alignment pins its right edge to the right-most map, so
     overflowing names grow leftward (and vice versa) instead of spilling past the strip */}
                  <div style={ al === "right"
                    ? { position: "absolute", top: 0, right: 0, fontSize: "11px", fontWeight: "bold", color: "#fff", textShadow: "0 0 3px #000", whiteSpace: "nowrap" }
                    : { position: "absolute", top: 0, left: 0, fontSize: "11px", fontWeight: "bold", color: "#fff", textShadow: "0 0 3px #000", whiteSpace: "nowrap" } }>
                    {al === "right" && <span onClick={(e) => { e.stopPropagation(); const id = s.d.id; setstripAdjust((prev) => ({ ...prev, [id]: { ...prev[id], align: "left" } })); }} style={{ cursor: "pointer", opacity: 0.6, marginRight: "5px" }}>⇤</span>}
                    {dungeonDisplayName(s.d)}
                    {al === "left" && <span onClick={(e) => { e.stopPropagation(); const id = s.d.id; setstripAdjust((prev) => ({ ...prev, [id]: { ...prev[id], align: "right" } })); }} style={{ cursor: "pointer", opacity: 0.6, marginLeft: "5px" }}>⇥</span>}
                  </div>
{/* // Right alignment also reverses the floor order, so floor 1 always faces the world map */}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", justifyContent: al === "right" ? "flex-end" : "flex-start" }}>{(al === "right" ? s.d.floors.slice().reverse() : s.d.floors).map((f) => floorTile(f))}</div>
                </div>
                );
              })}
            </>
          )}

        </div>

{/* // Map popover - mobs spawning on the clicked map this episode */}
        {popoverMap !== null && (
          <div className={`background-${currentEpisode}`} style={{ position: "absolute", right: "10px", top: "10px", width: "270px", maxWidth: "80%", maxHeight: "calc(100% - 20px)", overflow: "auto", zIndex: 20, padding: "10px", borderRadius: "4px", cursor: "auto" }}
            onPointerDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
              <div className={`title-${currentEpisode}`} style={{ fontWeight: "bold", fontSize: "15px", flex: 1 }}>{mapDisplayName(popoverMap)}</div>
              <span style={{ cursor: "pointer", fontWeight: "bold" }} onClick={() => setpopoverMap(null)}>✕</span>
            </div>
            <div style={{ opacity: 0.6, fontSize: "11px", marginBottom: "6px" }}>{popoverMap}</div>
            {popoverMobs.length === 0
              ? <div style={{ opacity: 0.7 }}>No spawns on this map.</div>
              : <ul style={{ margin: 0, paddingLeft: "18px" }}>
                  {popoverMobs.map((m) => (
                    <li key={m.mob_id} style={{ marginBottom: "2px" }}>
                      <span className="spawn-mob-link" onClick={() => { if (onMobClick) onMobClick(m.mob_id); }} style={{ cursor: "pointer" }}>{ index_mobs[m.mob_id] ? index_mobs[m.mob_id][currentLanguage] : m.mob_id }</span> - {m.quantity}
                    </li>
                  ))}
                </ul>
            }
          </div>
        )}

{/* // Dungeon panel - floor grid by depth (B5..B1 | 1..N), free grid for complexes (Glast Heim) */}
        {openDungeonData && (
          <div className={`background-${currentEpisode}`} style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", top: "10px", maxWidth: "min(94%, 980px)", maxHeight: "calc(100% - 20px)", overflow: "auto", zIndex: 20, padding: "12px", borderRadius: "4px", cursor: "auto" }}
            onPointerDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", alignItems: "baseline", gap: "6px", marginBottom: "8px" }}>
              <div className={`title-${currentEpisode}`} style={{ fontWeight: "bold", fontSize: "16px", flex: 1, whiteSpace: "nowrap" }}>{dungeonDisplayName(openDungeonData)}</div>
              <span style={{ cursor: "pointer", fontWeight: "bold" }} onClick={() => setopenDungeon(null)}>✕</span>
            </div>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {openDungeonData.floors
                .slice().sort((a, b) => (a.depth === null ? 0 : a.depth) - (b.depth === null ? 0 : b.depth))
                .map((f) => {
                  const hasSpawns = spawnMaps.has(f.map);
                  return (
                    <div key={f.map}
                      onClick={() => { if (hasSpawns) { setpopoverMap(f.map); setopenDungeon(null); } }}
                      style={{ width: "104px", textAlign: "center", cursor: hasSpawns ? "pointer" : "default", opacity: hasSpawns ? 1 : 0.35 }}>
                      <div className={`title-${currentEpisode}`} style={{ fontWeight: "bold", fontSize: "13px", marginBottom: "2px" }}>
                        {f.depth === null ? " " : (f.depth < 0 ? "B" + (-f.depth) : f.depth)}
                      </div>
                      <img src={getMapUrl(f.map, currentEpisode)} alt={f.map} draggable={false}
                        onError={(e) => { e.target.style.display = "none"; }}
                        style={{ width: "104px", height: "104px", display: "block", border: "1px solid rgba(0,0,0,0.6)" }} />
                      <div style={{ fontSize: "10px", opacity: 0.8, marginTop: "2px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{mapDisplayName(f.map)}</div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}


export default function App() {

  // Search Functions
  const [filteredMobs, setfilteredMobs] = useState([]);
  const [filteredItems, setfilteredItems] = useState([]);
  const [inputBusca, setinputBusca] = useState("");
  const [selectedMob, setselectedMob] = useState(null);
  const [selectedItem, setselectedItem] = useState(null);
  const [oldImageExists, setoldImageExists] = useState(true);
  const [cardImageExists, setcardImageExists] = useState(false);
  const cardImageRef = useRef(null);
  const suppressNextSearchEffectRef = useRef(false);
  const persistReadyRef = useRef(false);
  const [activeSpawnTab, setactiveSpawnTab] = useState("0");
  const [activeItemMapTab, setactiveItemMapTab] = useState("0");
  const [dropTableSort, setdropTableSort] = useState({ field: "slot", asc: true });

  // Global Parameters
  const [baseExpMultiplier, setbaseExpMultiplier] = useState("1");
  const [jobExpMultiplier, setjobExpMultiplier] = useState("1");
  const [dropRateMultiplier, setdropRateMultiplier] = useState("1");

  // Language Handling
  const [currentLanguage, setcurrentLanguage] = useState("en-us");

  // Set Current Language Function
  const handleChangeLanguage = async (language) => {
    setcurrentLanguage(language);
  };


  //  Episode Functions - Create variables, as well as create the functions that change their value.
  const [currentEpisode, setcurrentEpisode] = useState(DEFAULT_EPISODE);
  const [currentEpisodeItemDB, setcurrentEpisodeItemDB] = useState(items_default);
  const [currentEpisodeMobDB, setcurrentEpisodeMobDB] = useState(mobs_default);
  const [currentEpisodeMobSpawn, setcurrentEpisodeMobSpawn] = useState(spawn_default);
  const [currentEpisodeDroppedBy, setcurrentEpisodeDroppedBy] = useState(droppedBy);
  const [currentEpisodeItemDescription, setcurrentEpisodeItemDescription] = useState(item_descriptions_default);
  const [selectedEpisodeDetails, setselectedEpisodeDetails] = useState(null);

  // Episode Handling - Actually change stuff when a different episode is chosen
  const handleEpisodeChange = async (episode) => {
    try {
      const newDroppedBy = await import(`./jsons/${episode}/dropped_by_${episode}.json`);
      const newItemDB = await import(`./jsons/${episode}/item_db_${episode}.json`);
      const newItemDescription = await import(`./jsons/${episode}/item_description_${episode}.json`);
      const newMobDB = await import(`./jsons/${episode}/mob_db_${episode}.json`);
      const newMobSpawn = await import(`./jsons/${episode}/mob_spawn_${episode}.json`);
      setcurrentEpisodeDroppedBy(newDroppedBy.default);
      setcurrentEpisodeMobSpawn(newMobSpawn.default);
      setcurrentEpisodeItemDB(newItemDB.default);
      setcurrentEpisodeMobDB(newMobDB.default);
      setcurrentEpisodeItemDescription(newItemDescription.default);
      setcurrentEpisode(episode);
      {selectedEpisodeDetails !== null && (setselectedEpisodeDetails(episode))};

      // Re-select current mob/item in the new episode's data, or clear if not found
      if (selectedMob !== null) {
        const updatedMob = newMobDB.default.find((mob) => mob.ID == selectedMob.ID);
        setselectedMob(updatedMob || null);
      }
      if (selectedItem !== null) {
        const updatedItem = newItemDB.default.find((item) => item.ID == selectedItem.ID);
        setselectedItem(updatedItem || null);
      }

      // Batch all state resets that would otherwise be triggered by separate useEffects (extra renders)
      setactiveSpawnTab("0");
      setactiveItemMapTab("0");
      setoldImageExists(true);
      setcardImageExists(false);

      // Compute and set filtered results with new data — batched here to avoid an extra render from the search useEffect
      suppressNextSearchEffectRef.current = true;
      if (inputBusca === "" && !checkboxState) {
        setfilteredItems([]);
        setfilteredMobs([]);
      } else if (checkboxState && inputBusca === "") {
        setfilteredItems(hideNoDrop ? newItemDB.default.filter(item => newDroppedBy.default[item.ID] && newDroppedBy.default[item.ID].length > 0) : newItemDB.default);
        setfilteredMobs(hideNoSpawn ? newMobDB.default.filter(mob => newMobSpawn.default.some(s => s.mob_id == mob.ID)) : newMobDB.default);
      } else {
        const newFiltItems = newItemDB.default.filter((item) => {
          const fn = (index_items[item.ID] && index_items[item.ID][currentLanguage]) ? index_items[item.ID][currentLanguage] : (index_items[item.ID] && index_items[item.ID].FriendlyName) || item.FriendlyName || item.ShortName || "";
          return fn.toLowerCase().includes(inputBusca.toLowerCase()) || String(item.ID).includes(inputBusca);
        });
        setfilteredItems(hideNoDrop ? newFiltItems.filter(item => newDroppedBy.default[item.ID] && newDroppedBy.default[item.ID].length > 0) : newFiltItems);
        const newFiltMobs = newMobDB.default.filter((mob) => {
          const fn = (index_mobs[mob.ID] && index_mobs[mob.ID][currentLanguage]) ? index_mobs[mob.ID][currentLanguage] : (index_mobs[mob.ID] && index_mobs[mob.ID].AegisName) || mob.AegisName || mob.FriendlyName || "";
          return fn.toLowerCase().includes(inputBusca.toLowerCase()) || String(mob.ID).includes(inputBusca);
        });
        setfilteredMobs(hideNoSpawn ? newFiltMobs.filter(mob => newMobSpawn.default.some(s => s.mob_id == mob.ID)) : newFiltMobs);
      }
    } catch (error)
      {
      alert('Episode not supported yet');}
  };





  //  Site Pages - "about" / "timeline" (null = database view, no site page open)
  const [selectedPage, setselectedPage] = useState(null);

  //  Theme
  const [MENU_STYLE_CLASS, setMENU_STYLE_CLASS] = useState("title-left-container");
  const [showDebugPanel, setshowDebugPanel] = useState(false);
  const IS_ALT = MENU_STYLE_CLASS === "title-left-container-alt";

  //  Distribution Functions
  const [currentDistribution, setcurrentDistribution] = useState("iRO");
  const [currentDistributionItemDB, setcurrentDistributionItemDB] = useState("");
  const [currentDistributionMobDB, setcurrentDistributionMobDB] = useState("");

  const handleDistributionChange = async (distribution) => {
    try {

      throw new Error("Simulated error: Distribution change failed.");
      
      const newItemDB = await import(`./jsons/item_db_${distribution}.json`);
      const newMobDB = await import(`./jsons/mob_db_${distribution}.json`);
      setcurrentDistributionItemDB([newItemDB]);
      setcurrentDistributionMobDB([newMobDB]);
      setcurrentDistribution(distribution);
    } catch (error)
    {
      alert('Distribution not supported yet');}
  };






  // Checkbox functions
const [checkboxState, setCheckboxState] = useState(false);
const handleCheckboxChange = () => {
  setCheckboxState(prevState => !prevState);
};
const [hideNoSpawn, sethideNoSpawn] = useState(true); /* default ON for the whole site (also drives the Episode Details delta) */
const handleHideNoSpawnChange = () => {
  sethideNoSpawn(prevState => !prevState);
};
const [hideNoDrop, sethideNoDrop] = useState(true); /* default ON for the whole site (also drives the Episode Details delta) */
const handleHideNoDropChange = () => {
  sethideNoDrop(prevState => !prevState);
};


// Reset spawn map tab when a different mob is selected
useEffect(() => { setactiveSpawnTab("0"); }, [selectedMob]);
const debugMissing = useMemo(() => {
  if (!showDebugPanel) return [];
  const allMobEntries = {};
  let uniqueCounter = 0;
  const addID = (id, name, source, context) => {
    const hasValidID = id !== null && id !== undefined && id !== "";
    const key = hasValidID ? String(id) : `__missing_${uniqueCounter++}`;
    if (!allMobEntries[key]) allMobEntries[key] = { id: hasValidID ? String(id) : null, rawID: id, name: name || null, source, context: context || null };
    if (!allMobEntries[key].name && name) allMobEntries[key].name = name;
  };
  currentEpisodeMobDB.forEach(mob => addID(mob.ID, mob.AegisName, "mob_db"));
  currentEpisodeMobSpawn.forEach((entry, i) => addID(entry.mob_id, entry.AegisName, "mob_spawn", `[${i}] mapname="${entry.mapname}"`));
  Object.entries(currentEpisodeDroppedBy).forEach(([itemID, arr]) => arr.forEach(entry => addID(entry.mob_id, entry.mob, "dropped_by", `item ${itemID}`)));
  return Object.values(allMobEntries)
    .filter(entry => !entry.id || !index_mobs[entry.id])
    .sort((a, b) => Number(a.id) - Number(b.id));
}, [currentEpisodeMobDB, currentEpisodeMobSpawn, currentEpisodeDroppedBy, showDebugPanel]);
const debugMissingItems = useMemo(() => {
  if (!showDebugPanel) return [];
  return currentEpisodeItemDB
    .filter(item => !index_items[String(item.ID)])
    .map(item => ({ id: String(item.ID), name: item.FriendlyName || item.ShortName || item.NAME || null }))
    .sort((a, b) => Number(a.id) - Number(b.id));
}, [currentEpisodeItemDB, showDebugPanel]);
const debugDroppedByItemsMissing = useMemo(() => {
  if (!showDebugPanel) return [];
  return Object.keys(currentEpisodeDroppedBy)
    .filter(itemID => !index_items[itemID])
    .map(itemID => {
      const mobs = currentEpisodeDroppedBy[itemID].map(e => e.mob_id);
      return { itemID, mobs };
    })
    .sort((a, b) => Number(a.itemID) - Number(b.itemID));
}, [currentEpisodeDroppedBy, showDebugPanel]);
const debugDuplicates = useMemo(() => {
  if (!showDebugPanel) return [];
  const check = (arr) => { const c = new Map(); arr.forEach(e => c.set(e.ID, (c.get(e.ID) || 0) + 1)); return [...c.entries()].filter(([_, n]) => n > 1).map(([id]) => id); };
  return [...check(currentEpisodeMobDB).map(id => `mob ${id}`), ...check(currentEpisodeItemDB).map(id => `item ${id}`)];
}, [currentEpisodeMobDB, currentEpisodeItemDB, showDebugPanel]);
useEffect(() => { setoldImageExists(true); setcardImageExists(false); setactiveItemMapTab("0"); }, [selectedItem]);

// Check if card image loaded successfully (handles cached images too)
useEffect(() => {
  const img = cardImageRef.current;
  if (img && img.complete) {
    setcardImageExists(img.naturalHeight > 0);
  }
}, [selectedItem]);

// PERSIST STATE TO LOCALSTORAGE — guarded by persistReadyRef so initial mount doesn't overwrite saved values
useEffect(() => { if (!persistReadyRef.current) return; localStorage.setItem('ragdb_episode', currentEpisode); }, [currentEpisode]);
useEffect(() => { if (!persistReadyRef.current) return; if (selectedMob)  localStorage.setItem('ragdb_mob_id',  String(selectedMob.ID));  else localStorage.removeItem('ragdb_mob_id');  }, [selectedMob]);
useEffect(() => { if (!persistReadyRef.current) return; if (selectedItem) localStorage.setItem('ragdb_item_id', String(selectedItem.ID)); else localStorage.removeItem('ragdb_item_id'); }, [selectedItem]);

// RESTORE STATE FROM LOCALSTORAGE ON MOUNT
useEffect(() => {
  const savedEpisode = localStorage.getItem('ragdb_episode');
  const savedMobId   = localStorage.getItem('ragdb_mob_id');
  const savedItemId  = localStorage.getItem('ragdb_item_id');
  const restore = async () => {
    try {
      if (savedEpisode) {
        const newDroppedBy       = await import(`./jsons/${savedEpisode}/dropped_by_${savedEpisode}.json`);
        const newItemDB          = await import(`./jsons/${savedEpisode}/item_db_${savedEpisode}.json`);
        const newItemDescription = await import(`./jsons/${savedEpisode}/item_description_${savedEpisode}.json`);
        const newMobDB           = await import(`./jsons/${savedEpisode}/mob_db_${savedEpisode}.json`);
        const newMobSpawn        = await import(`./jsons/${savedEpisode}/mob_spawn_${savedEpisode}.json`);
        setcurrentEpisodeDroppedBy(newDroppedBy.default);
        setcurrentEpisodeMobSpawn(newMobSpawn.default);
        setcurrentEpisodeItemDB(newItemDB.default);
        setcurrentEpisodeMobDB(newMobDB.default);
        setcurrentEpisodeItemDescription(newItemDescription.default);
        setcurrentEpisode(savedEpisode);
        suppressNextSearchEffectRef.current = true;
        if (savedMobId)  { const mob  = newMobDB.default.find(m  => String(m.ID)  === savedMobId);  if (mob)  setselectedMob(mob);  }
        if (savedItemId) { const item = newItemDB.default.find(i  => String(i.ID)  === savedItemId); if (item) setselectedItem(item); }
      }
    } catch (e) {}
    persistReadyRef.current = true;
  };
  restore();
}, []);

// SEARCH BAR LOGIC
useEffect(() => { if (suppressNextSearchEffectRef.current) { suppressNextSearchEffectRef.current = false; return; } search(); }, [inputBusca, currentLanguage, currentEpisode, checkboxState, hideNoSpawn, hideNoDrop]);



// START SEARCH LOGIC
const search = () => {
  if (inputBusca === "" && !checkboxState) {
    setfilteredItems([]); /* Cleans the result lists when search bar is empty */
    setfilteredMobs([]); /* Cleans the result lists when search bar is empty */
    return;
  }




  if (checkboxState && inputBusca === "") {
    setfilteredItems(hideNoDrop ? currentEpisodeItemDB.filter(item => currentEpisodeDroppedBy[item.ID] && currentEpisodeDroppedBy[item.ID].length > 0) : currentEpisodeItemDB);
    setfilteredMobs(hideNoSpawn ? currentEpisodeMobDB.filter(mob => currentEpisodeMobSpawn.some(s => s.mob_id == mob.ID)) : currentEpisodeMobDB);
    return;
  }

  // Updates Filtered Items array with search input
  const filteredItems = currentEpisodeItemDB.filter((item) => {
    const friendlyName =
      (index_items[item.ID] && index_items[item.ID][currentLanguage])
        ? index_items[item.ID][currentLanguage]
        : (index_items[item.ID] && index_items[item.ID].FriendlyName) || item.FriendlyName || item.ShortName || "";

    return (
      friendlyName.toLowerCase().includes(inputBusca.toLowerCase()) ||
      String(item.ID).includes(inputBusca)
    );
  });

  setfilteredItems(hideNoDrop ? filteredItems.filter(item => currentEpisodeDroppedBy[item.ID] && currentEpisodeDroppedBy[item.ID].length > 0) : filteredItems);

  // Updates Filtered Mob array with search input
  const filteredMobs = currentEpisodeMobDB.filter((mob) => {
    const friendlyName =
      (index_mobs[mob.ID] && index_mobs[mob.ID][currentLanguage])
        ? index_mobs[mob.ID][currentLanguage]
        : (index_mobs[mob.ID] && index_mobs[mob.ID].AegisName) || mob.AegisName || mob.FriendlyName || "";

    return (
      friendlyName.toLowerCase().includes(inputBusca.toLowerCase()) ||
      String(mob.ID).includes(inputBusca)
    );
  });

  setfilteredMobs(hideNoSpawn ? filteredMobs.filter(mob => currentEpisodeMobSpawn.some(s => s.mob_id == mob.ID)) : filteredMobs);
};

  
 

  // Make Item's 'Dropped by" list clickable
  const makeDroppedByClickable = (mobId) => {
    setselectedItem(null);
    const newSelectedMob = currentEpisodeMobDB.find((mob) => mob.ID == mobId); /* FIX === HERE */
    setselectedMob(newSelectedMob);
    /* Reset select lists so clicking the same mob/item again triggers onChange */
    { const s = document.getElementById('item-select'); if (s) s.selectedIndex = -1; } /* null when a site page is open (left panel unmounted) */
    { const s = document.getElementById('mob-select'); if (s) s.selectedIndex = -1; }
  };

  // Make Mob's "drop list" clickable
  const makeDropClickable = (itemId) => {
    setselectedMob(null);
    const newSelectedItem = currentEpisodeItemDB.find((item) => item.ID == itemId); /* FIX === HERE */
    setselectedItem(newSelectedItem);
    /* Reset select lists so clicking the same mob/item again triggers onChange */
    { const s = document.getElementById('item-select'); if (s) s.selectedIndex = -1; } /* null when a site page is open (left panel unmounted) */
    { const s = document.getElementById('mob-select'); if (s) s.selectedIndex = -1; }
  };


  const getDroppedBy = (itemId) => {
    const filteredMobs = currentEpisodeMobDB.filter((mob) => {
      const keysToCheck = ['Drop1', 'Drop2', 'Drop3', 'Drop4', 'Drop5', 'Drop6', 'Drop7', 'Drop8', 'Drop9'];
      const hasValue = keysToCheck.some(key => mob[key] === itemId);
      return hasValue;
    })

    const droppedByObj = filteredMobs.map((mob) => {
      return {Rate: mob.rate, mob_id: mob.ID, mob_name: mob.FriendlyName};
    })
  };



  

const SpawnMaps = ({ ID }) => {
  const filteredMaps = currentEpisodeMobSpawn.filter((entry) => entry.mob_id === ID);
  const mapIDs = filteredMaps.map((entry) => entry.mapname);

  const allMonstersInMaps = currentEpisodeMobSpawn.filter((entry) =>
    mapIDs.includes(entry.mapname)
  );

  const spawnList = filteredMaps.map((entry) => (
    <p key={entry.mob_id + entry.mapname}>
      <b>{entry.mapname}</b>
      <ul>
        {allMonstersInMaps
          .filter((line) => line.mapname == entry.mapname)
          .map((line2) => (
            <li>
              {" "}
              {line2.FriendlyName} - {line2.quantity}{" "}
            </li>
          ))}
      </ul>
    </p>
  ));
  return spawnList;
};






{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* APP RETURN */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

  return (

/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/
/* WRAPPER DIV */
/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/

<div className={`global-${currentEpisode}`}
style={{minHeight: "100vh",  overflow: "auto", /* Prevent margin collapse */}}>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* TOP + LEFT + RIGHT CONTAINERS */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}


    <div className={`App`}>


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* TOP MENU */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

      <div>{/* TOP MENU */}
        <div >
{/* // Top bar without container box - logo and banner float directly on the page */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div className={`title-${currentEpisode}`} ><img src="/img/logo.png" alt="RagnaDB" style={{ maxHeight: "60px" }} /></div>

{/* // Site Pages Nav Menu - Database / Timeline / About the project / Discord */}
            <button className={`title-${currentEpisode} nav-menu-button`}
            onClick={() => {
              setselectedPage(null);
            }}>Database</button>
            <button className={`title-${currentEpisode} nav-menu-button`}
            onClick={() => {
              setselectedItem(null);
              setselectedMob(null);
              setselectedEpisodeDetails(null);
              setselectedPage("timeline");
              /* Reset both lists so clicking the same item/mob again triggers onChange */
              { const s = document.getElementById('item-select'); if (s) s.selectedIndex = -1; } /* null when a site page is open (left panel unmounted) */
              { const s = document.getElementById('mob-select'); if (s) s.selectedIndex = -1; }
            }}>Timeline</button>
            <button className={`title-${currentEpisode} nav-menu-button`}
            onClick={() => {
              setselectedItem(null);
              setselectedMob(null);
              setselectedEpisodeDetails(null);
              setselectedPage("about");
              /* Reset both lists so clicking the same item/mob again triggers onChange */
              { const s = document.getElementById('item-select'); if (s) s.selectedIndex = -1; } /* null when a site page is open (left panel unmounted) */
              { const s = document.getElementById('mob-select'); if (s) s.selectedIndex = -1; }
            }}>About the project</button>
            <a className={`title-${currentEpisode} nav-menu-button`} style={{ textDecoration: "none" }} href="https://discord.gg/Cpe6rMN2UR" target="_blank" rel="noopener noreferrer">Discord</a>

{/* // Secret Debug Button */}
            <button onClick={() => setshowDebugPanel(v => !v)} style={{ background: "transparent", border: "none", color: "transparent", cursor: "pointer", width: "16px", height: "16px", padding: 0, userSelect: "none" }}>·</button>
            {showDebugPanel && (
                <div style={{ position: "fixed", top: "60px", right: "10px", zIndex: 9999, background: "#1e1e1e", color: "#d4d4d4", fontFamily: "monospace", fontSize: "12px", padding: "12px", borderRadius: "6px", maxHeight: "400px", overflowY: "auto", minWidth: "280px", boxShadow: "0 4px 16px rgba(0,0,0,0.5)" }}>
                  <div style={{ fontWeight: "bold", marginBottom: "8px" }}>ep {currentEpisode}</div>

                  {debugMissing.length === 0
                    ? <div style={{ color: "#6a9955", marginBottom: "6px" }}>✓ All mobs from dropped_by and mob_spawn found in index_mobs</div>
                    : <>
                        <div style={{ color: "#f0a500", fontWeight: "bold", marginBottom: "4px" }}>⚠ index_mobs missing ({debugMissing.length})</div>
                        {debugMissing.map((entry, i) => <div key={i} style={{ marginBottom: "2px" }}>
                          {entry.id
                            ? <>{entry.id} — {entry.name || "?"} ({entry.source})</>
                            : entry.source === "dropped_by"
                              ? <>item ID {entry.context.replace("item ", "")}: dropped by mob_id "{String(entry.rawID)}" (dropped_by)</>
                              : entry.source === "mob_spawn"
                                ? <>map {entry.context}: spawn with mob_id "{String(entry.rawID)}" (mob_spawn)</>
                                : <>[no ID] — {entry.name || "?"} ({entry.source})</>
                          }
                        </div>)}
                      </>
                  }

                  {debugMissingItems.length === 0
                    ? <div style={{ color: "#6a9955" }}>✓ All items from item_db found in index_items</div>
                    : <>
                        <div style={{ color: "#f0a500", fontWeight: "bold", marginBottom: "4px", marginTop: "6px" }}>⚠ index_items missing ({debugMissingItems.length})</div>
                        {debugMissingItems.map((entry, i) => <div key={i} style={{ marginBottom: "2px" }}>{entry.id} — {entry.name || "?"}</div>)}
                      </>
                  }

                  {debugDroppedByItemsMissing.length === 0
                    ? <div style={{ color: "#6a9955", marginTop: "6px" }}>✓ All items in dropped_by found in index_items</div>
                    : <>
                        <div style={{ color: "#f0a500", fontWeight: "bold", marginBottom: "4px", marginTop: "6px" }}>⚠ dropped_by items missing from index_items ({debugDroppedByItemsMissing.length})</div>
                        {debugDroppedByItemsMissing.map((entry, i) => <div key={i} style={{ marginBottom: "2px" }}>item {entry.itemID} — dropped by: {entry.mobs.join(", ")}</div>)}
                      </>
                  }

                  {debugDuplicates.length === 0
                    ? <div style={{ color: "#6a9955", marginTop: "6px" }}>✓ No duplicate IDs</div>
                    : <>
                        <div style={{ color: "#f0a500", fontWeight: "bold", marginBottom: "4px", marginTop: "6px" }}>⚠ Duplicate IDs ({debugDuplicates.length})</div>
                        {debugDuplicates.map((entry, i) => <div key={i} style={{ marginBottom: "2px" }}>{entry}</div>)}
                      </>
                  }
                </div>
            )}




 
{/* // Banner */}               

            <div style={{ width: '100%', textAlign: 'right' }}>
        <img 
          src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/headers/header-${currentEpisode}.gif`}
          alt="Header Banner" 
          style={{ width: '90%', maxWidth: '700px' }} // Adjust width as needed
        />
      </div>


          </div>

{/* // Grey Bar */}
          <hr />

{/* // OPTIONS BAR - only in Database view, below the separator line */}
{selectedPage === null && (
          <div className={`background-${currentEpisode}`} style={{ display: "flex", gap: "10px", alignItems: "center", padding: "12px 20px", marginBottom: "18px" }}>

{/* // Base Rate Dropdown Menu */}
            <div className={`title-${currentEpisode}`}>Base:</div>
            <RateInput
              style={{ minWidth: "27px", maxWidth: "35px", textAlign: "Center"  }}
              value={baseExpMultiplier}
              onChange={setbaseExpMultiplier}
            />

{/* // Job Rate Dropdown Menu */}
            <div className={`title-${currentEpisode}`}>Job:</div>
            <RateInput
              style={{ maxWidth: "27px", maxWidth: "35px", textAlign: "Center"  }}
              value={jobExpMultiplier}
              onChange={setjobExpMultiplier}
            />

{/* // Drop Rate Dropdown Menu */}
            <div className={`title-${currentEpisode}`}>Drop:</div>
            <RateInput
              style={{ maxWidth: "27px", maxWidth: "35px", textAlign: "Center" }}
              value={dropRateMultiplier}
              onChange={setdropRateMultiplier}
            />

{/* // Language Dropdown Menu */}
            <div className={`title-${currentEpisode}`}>Language:</div>
            <select
              value={currentLanguage}
              onChange={(e) => handleChangeLanguage(e.target.value)}
            >
              <option value="en-us">English</option>
              <option value="pt-br">Português</option>
            </select>

{/* // Distribution Dropdown Menu */}
            <div className={`title-${currentEpisode}`}>Distribution:</div>
            <select
              value={currentDistribution}
              onChange={(e) => setcurrentDistribution(e.target.value)}
            >
              <option value="iRO">iRO</option>
              <option value="kRO">kRO</option>
              <option value="bRO">bRO</option>

            </select>

{/* // Theme Picker Menu */}
            <div className={`title-${currentEpisode}`}>Theme:</div>
            <select
              value={MENU_STYLE_CLASS}
              onChange={(e) => setMENU_STYLE_CLASS(e.target.value)}
            >
              <option value="title-left-container">Standard</option>
              <option value="title-left-container-alt">RO Theme</option>

            </select>

          </div>
)}{/* // OPTIONS BAR END */}


{/* // Main Container */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "25px",
              height: selectedPage === null ? "calc(100vh - 240px)" : "calc(100vh - 200px)", /* 240px = Database view with the options bar; 200px = site pages where the options bar is hidden */
            }}
          >

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // LEFT CONTAINER */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

{(selectedPage === null || selectedPage === "worldmap") && ( /* worldmap keeps the left panel: episode switching updates the map live */
            <div style={{ display: "flex", flexDirection: "column", width: "240px" }}>

{/* // Search Box */}

<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Search</div>{/* marginTop 0: left column top must align with the right container top in BOTH themes */}
<input
  placeholder="Item/mob name or ID"
  value={inputBusca}
  onChange={(e) => setinputBusca(e.target.value)}
  style={{ width: "100%", height:"30px" }}
/>

{/* Checkboxes are NOT titles — do not apply title-left-container or title classes here */}
<label style={{ alignSelf: "flex-start" }}><input
          type="checkbox"
          checked={checkboxState}
          onChange={handleCheckboxChange}
        /> Show All</label>
<label style={{ alignSelf: "flex-start" }}><input
          type="checkbox"
          checked={hideNoSpawn}
          onChange={handleHideNoSpawnChange}
        /> Hide Mobs without spawn</label>
<label style={{ alignSelf: "flex-start" }}><input
          type="checkbox"
          checked={hideNoDrop}
          onChange={handleHideNoDropChange}
        /> Hide Items that don't drop</label>

{/* // Episode Dropdown Menu */}
<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`}>Episode</div>
<select
  value={currentEpisode}
  onChange={(e) => handleEpisodeChange(e.target.value)}
  style={{ width: "100%", height:"30px"  }}
>
              <option value="default">Test</option>


              {/* Alpha Era */}
              <option value="00" disabled={!AVAILABLE_EPISODES.has("00")}>Ep.00 - Alpha Era</option>
              {/* <option value="00000" disabled={!AVAILABLE_EPISODES.has("00000")}>Ep.00000 - Alpha Era</option> */}

              {/* Beta Era */}
              <option value="0" disabled={!AVAILABLE_EPISODES.has("0")}>Ep.0 - Beta Era</option>
              {/* <option value="0000" disabled={!AVAILABLE_EPISODES.has("0000")}>Ep.0000 - MBT 1</option> */}
              {/* <option value="000" disabled={!AVAILABLE_EPISODES.has("000")}>Ep.000 - MBT 1, Part 2</option> */}
              {/* <option value="00" disabled={!AVAILABLE_EPISODES.has("00")}>Ep.00 - CBT 2</option> */}
              {/* <option value="0" disabled={!AVAILABLE_EPISODES.has("0")}>Ep.0 - OBT 2</option> */}

              {/* Launch Era */}
              <option value="1" disabled={!AVAILABLE_EPISODES.has("1")}>Ep.1 - Start of an Adventure</option>

              {/* Clock Tower + GH Dun */}
              <option value="1-5" disabled={!AVAILABLE_EPISODES.has("1-5")}>Ep.1.5 - Attack of the Ancient (Clock Tower + GH dun)</option>


              {/* Lutie */}
              <option value="2" disabled={!AVAILABLE_EPISODES.has("2")}>Ep.2 - Lutie</option>

              {/* Comodo */}
              <option value="3" disabled={!AVAILABLE_EPISODES.has("3")}>Ep.3 - Comodo</option>

              {/* Turtle Island + Woe Era */}
              <option value="4" disabled={!AVAILABLE_EPISODES.has("4")}>Ep.4 - Turtle Island + WoE</option>

              {/* Juno Era */}
              <option value="5" disabled={!AVAILABLE_EPISODES.has("5")}>Ep.5 - Juno</option>

              {/* Old Times Era */}
              {/* <option value="7" disabled={!AVAILABLE_EPISODES.has("7")}>Ep.6~7 - Old Times Era</option> */}
              <option value="6" disabled={!AVAILABLE_EPISODES.has("6")}>Ep.6 - Amatsu</option>
              <option value="6-2" disabled={!AVAILABLE_EPISODES.has("6-2")}>Ep.6.2 - Kunlun</option>
              <option value="7" disabled={!AVAILABLE_EPISODES.has("7")}>Ep.7 - Umbala</option>
              <option value="7-1" disabled={!AVAILABLE_EPISODES.has("7-1")}>Ep.7.1 - Nifflheim</option>


              {/* Heritage Era */}
              {/* <option value="10" disabled={!AVAILABLE_EPISODES.has("10")}>Ep.8~10 - Heritage Era</option> */}
              <option value="8-1" disabled={!AVAILABLE_EPISODES.has("8-1")}>Ep.8.1 - Louyang</option>
              <option value="8-2" disabled={!AVAILABLE_EPISODES.has("8-2")}>Ep.8.2 - Ayothaya</option>
              {/* <option value="10" disabled={!AVAILABLE_EPISODES.has("10")}>Ep.10 - Rebirth</option> */}
              {/* <option value="10-05" disabled={!AVAILABLE_EPISODES.has("10-05")}>Ep.10.05 - Jawaii</option> */}

              {/* Gold Times Era */}
              {/* <option value="11" disabled={!AVAILABLE_EPISODES.has("11")}>Ep.10~11 - Gold Times Era</option> */}
              <option value="10-1" disabled={!AVAILABLE_EPISODES.has("10-1")}>Ep.10.1 - Einbroch</option>
              <option value="10-2" disabled={!AVAILABLE_EPISODES.has("10-2")}>Ep.10.2 - Lighthalzen</option>
              {/* <option value="10-25" disabled={!AVAILABLE_EPISODES.has("10-25")}>Ep.10.25 - Homunculus</option> */}
              <option value="10-3" disabled={!AVAILABLE_EPISODES.has("10-3")}>Ep.10.3 - Noghaltz</option>
              <option value="10-4" disabled={!AVAILABLE_EPISODES.has("10-4")}>Ep.10.4 - Hugel</option>
              <option value="11-1" disabled={!AVAILABLE_EPISODES.has("11-1")}>Ep.11.1 - Rachel</option>
              <option value="11-2" disabled={!AVAILABLE_EPISODES.has("11-2")}>Ep.11.2 - Veins</option>
              <option value="11-3" disabled={!AVAILABLE_EPISODES.has("11-3")}>Ep.11.3 - Nameless Island</option>

              {/* Satan Morroc Era */}
              <option value="12" disabled={!AVAILABLE_EPISODES.has("12")}>Ep.12~13 - Satan Morroc Era</option>
              {/* <option value="12" disabled={!AVAILABLE_EPISODES.has("12")}>Ep.12 - Satan Morroc</option> */}
              {/* <option value="12-1" disabled={!AVAILABLE_EPISODES.has("12-1")}>Ep.12.1 - WOE : SE</option> */}
              {/* <option value="12-2" disabled={!AVAILABLE_EPISODES.has("12-2")}>Ep.12.2 - Moscovia</option> */}
              {/* <option value="12-3" disabled={!AVAILABLE_EPISODES.has("12-3")}>Ep.12.3 - Battlegrounds</option> */}
              {/* <option value="12-4" disabled={!AVAILABLE_EPISODES.has("12-4")}>Ep.12.4 - Endless Tower</option> */}
              {/* <option value="12-5" disabled={!AVAILABLE_EPISODES.has("12-5")}>Ep.12.5 - Sealed Shrine</option> */}
              <option value="13-1" disabled={!AVAILABLE_EPISODES.has("13-1")}>Ep.13.1 - Ash Vacuum</option>
              {/* <option value="13-11" disabled={!AVAILABLE_EPISODES.has("13-11")}>Ep.13.11 - Poring Wars</option> */}


              {/* Renewal */}
              {/* <option value="13" disabled={!AVAILABLE_EPISODES.has("13")}>Ep.13+ - Renewal</option> */}
              {/* <option value="13-15" disabled={!AVAILABLE_EPISODES.has("13-15")}>Ep.13.15 - Renewal</option> */}
              <option value="13-2" disabled={!AVAILABLE_EPISODES.has("13-2")}>Ep.13.2 - Into the Unknown</option>
              
            </select>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ITEM RESULTS LIST */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`}>Items</div>
<select className="results-list"
  id="item-select"
  style={{ textAlign: "left", width: "100%", outline: "none", flex: 1, minHeight: "100px" }}
  size="13"
  onChange={(event) => {
    const selectedID = event.target.value;
    const item = filteredItems.find(item => item.ID === selectedID);
    if (item) {
      setselectedMob(null);
      setselectedEpisodeDetails(null);
      setselectedPage(null);
      /* Reset mob list so clicking the same mob again triggers onChange */
      { const s = document.getElementById('mob-select'); if (s) s.selectedIndex = -1; }
      // Force reloading the same item by setting state to null before updating it
      setselectedItem(null); // Optional: reset selected item first
      setTimeout(() => {
        setselectedItem(item);
      }, 0);
    }
  }}
>
  {filteredItems.map((item) => (
    <option key={item.ID} value={item.ID}>
      {item.ID} - { index_items[item.ID] ? index_items[item.ID][currentLanguage] : ("* - " + (item.FriendlyName || item.ShortName || item.NAME)) } {Number(item.Slots || item.SLOT || item.Slot) > 0 && `[${item.Slots || item.SLOT || item.Slot}]`}{/* Slots: must use Number() — do NOT revert to string comparison, it breaks display. Check Slots/SLOT/Slot because different episodes use different field names */}
    </option>
  ))}
</select>


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // MOB RESULTS LIST */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`}>Monsters</div>
<select className="results-list"
  id="mob-select"
  style={{ textAlign: "left", width: "100%", outline: "none", flex: 1, minHeight: "100px" }}
  size="13"
  onChange={(event) => {
    const selectedID = event.target.value;
    const mob = filteredMobs.find(mob => mob.ID === selectedID);
    if (mob) {
      setselectedItem(null);
      setselectedEpisodeDetails(null);
      setselectedPage(null);
      /* Reset item list so clicking the same item again triggers onChange */
      { const s = document.getElementById('item-select'); if (s) s.selectedIndex = -1; } /* null when a site page is open (left panel unmounted) */
      // Force reloading the same mob by setting state to null before updating it
      setselectedMob(null); // Optional: reset selected mob first
      setTimeout(() => {
        setselectedMob(mob);
      }, 0);
    }
  }}
>
  {filteredMobs.map((mob) => {
    if (!index_mobs[mob.ID]) console.warn(`[index_mobs] missing mob ID: ${mob.ID} (${mob.AegisName})`);
    return (
      <option key={mob.ID} value={mob.ID}>
        {mob.ID} - { index_mobs[mob.ID] ? index_mobs[mob.ID][currentLanguage] || ("* - " + mob.AegisName) : ("* - " + mob.AegisName) }
      </option>
    );
  })}
</select>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // EPISODE DETAILS BUTTON */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}



<div style={{ marginTop: "auto", paddingTop: "20px" }}>
      <button style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", textAlign: "center", color: "inherit", backgroundColor: "rgba(255,255,255,0.12)" }}

      onClick={() => {
        setselectedItem(null);
        setselectedMob(null);
        setselectedEpisodeDetails(currentEpisode);
        setselectedPage(null);
        /* Reset both lists so clicking the same item/mob again triggers onChange */
        { const s = document.getElementById('item-select'); if (s) s.selectedIndex = -1; } /* null when a site page is open (left panel unmounted) */
        { const s = document.getElementById('mob-select'); if (s) s.selectedIndex = -1; }
       {/* alert('Button was clicked!'); */}
      }}>
        <p style={{ cursor: 'pointer', padding: '10px', margin: 0, }}>Episode Details</p>
      </button>

{/* // WORLD MAP BUTTON - opens the interactive per-episode Midgard map (site page, like Timeline) */}
      <button style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", textAlign: "center", color: "inherit", backgroundColor: "rgba(255,255,255,0.12)", marginTop: "8px" }}

      onClick={() => {
        setselectedItem(null);
        setselectedMob(null);
        setselectedEpisodeDetails(null);
        setselectedPage("worldmap");
        /* Reset both lists so clicking the same item/mob again triggers onChange */
        { const s = document.getElementById('item-select'); if (s) s.selectedIndex = -1; } /* null when a site page is open (left panel unmounted) */
        { const s = document.getElementById('mob-select'); if (s) s.selectedIndex = -1; }
      }}>
        <p style={{ cursor: 'pointer', padding: '10px', margin: 0, }}>World Map</p>
      </button>
</div>




{/* // End Left Container*/}
            </div>
)}
{/* // Start Right Container*/}



{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // RIGHT CONTAINER */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
            <div
            className={IS_ALT ? "" : `background-${currentEpisode}`}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                minWidth: 0,
                height: "100%",
               /*  border: "1px solid grey", */
                textAlign: "Left",
                gap: IS_ALT ? "20px" : undefined,
              }}
            >

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ITEM DETAILS */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

{!IS_ALT && <>
              {selectedItem !== null && (
                <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden", gap: IS_ALT ? "20px" : undefined }}>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ITEM - RIGHT-TOP */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ flex: `0 0 ${HEIGHT_RIGHT_TOP}`, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Details</div>}
                <div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: IS_ALT ? "8px 0 0 8px" : "12px 20px" }}>

{/* // ITEM HEADER - Icon + Name + ID */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                  <div style={{ backgroundColor: "#e8e8e8", padding: "6px", display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: "4px" }}><img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/icons/${selectedItem.ID}.png`} alt="" /></div>
                  <div>
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>{ index_items[selectedItem.ID] ? index_items[selectedItem.ID][currentLanguage] : (selectedItem.FriendlyName || selectedItem.ShortName || selectedItem.NAME) } {Number(selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot) > 0 && `[${selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot}]`}</div>
                    <div style={{ fontSize: "11px", opacity: 0.7 }}>{selectedItem.ID} | {selectedItem.ShortName || selectedItem.FriendlyName || selectedItem.NAME} | { index_items[selectedItem.ID] ? index_items[selectedItem.ID].AegisName : ""}</div>
                  </div>
                </div>

{/* // ITEM BODY - Image left, Details right */}
                <div style={{ display: "flex", gap: "12px" }}>

{/* // ITEM IMAGES */}
                  <div style={{ flexShrink: 0, display: "flex", gap: "12px" }}>
                    <div style={{ textAlign: "center" }}>
                      <img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/images/${selectedItem.ID}.png`} alt="" />
                      <div style={{ fontSize: "10px", opacity: 0.7 }}>New Image</div>
                    </div>
                    {oldImageExists && <div style={{ textAlign: "center" }}>
                      <img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/images-old/${selectedItem.ID}.png`} alt=""
                        onError={() => setoldImageExists(false)}
                      />
                      <div style={{ fontSize: "10px", opacity: 0.7 }}>Old Image</div>
                    </div>}
                  </div>
{/* // ITEM DETAILS */}
                  <div>

  {/* Description --- from "ITEM_DESCRIPTION.JSON" - full width, above the two columns */}
  {currentEpisodeItemDescription[selectedItem.ID]?.description && (<div style={{ marginBottom: "8px" }}>{currentEpisodeItemDescription[selectedItem.ID]?.description}</div>)}

{/* // ITEM DETAILS - TWO COLUMNS */}
                  <div style={{ display: "flex", gap: "20px" }}>

{/* // ITEM DETAILS - COLUMN 1 */}
                  <div>
                <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>

  {/* from ITEM_DESCRIPTION.JSON  */}
  {/* Item Class --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.item_class && (<li><b>{generalindex[currentLanguage].general.item_class}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.item_class}</li>)}
  {/* Compound_on --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.compound_on && (<li><b>{generalindex[currentLanguage].general.compound_on || "Compound on"}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.compound_on}</li>)}
  {/* Def --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.defense && (<li><b>{generalindex[currentLanguage].general.defense}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.defense}</li>)}
  {/* Weight  --- from  "ITEM_DESCRIPTION.JSON" */}  {currentEpisodeItemDescription[selectedItem.ID]?.weight && (<li><b>{generalindex[currentLanguage].general.weight}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.weight}</li>)}
  {/* Required_lvl --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.level_required && (<li><b>{generalindex[currentLanguage].general.level_required}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.level_required}</li>)}
  {/* Applicable_jobs --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.applicable_jobs && (<li><b>{generalindex[currentLanguage].general.applicable_jobs}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.applicable_jobs}</li>)}

                </ul>
                  </div>

{/* // ITEM DETAILS - COLUMN 2 */}
                  <div>
                <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>

  {/* from ITEM_DB.JSON  */}
  {/* Buy At --- from ITEM_DB*/} <li><b>{generalindex[currentLanguage].general.npc_price || "Buy At"}: </b>{selectedItem.NPCPrice || selectedItem.Price || selectedItem.PRICE}z</li>
  {/* Sell At --- from ITEM_DB */} <li><b>{generalindex[currentLanguage].general.sell_at || "Sell At"}: </b>{(selectedItem.NPCPrice || selectedItem.Price || selectedItem.PRICE) / 2}z</li>
  {/* Slots --- from ITEM_DB */} {Number(selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot) > 0 && (<li><b>Slots: </b>{selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot}</li>)}

  {/* DUPLICATE STUFF  */}
  {/* Lvl_req --- from ITEM_DB */} {Number(selectedItem.MinLvl || selectedItem.equipableLevel || selectedItem.level_required || selectedItem.eLV) > 0 && (<li><b>{generalindex[currentLanguage].general.level_required || "Level Required"}: </b>{selectedItem.MinLvl || selectedItem.equipableLevel || selectedItem.level_required || selectedItem.eLV}</li>)}
  {/* ATK --- from ITEM_DB */} {Number(selectedItem.ATK || selectedItem.weapon_attack) > 0 && (<li><b>ATK: </b>{selectedItem.ATK || selectedItem.weapon_attack}</li>)}
  {/* Weapon_atk --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.weapon_attack && (<li><b>{generalindex[currentLanguage].general.weapon_attack}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.weapon_attack}</li>)}
  {/* DEF --- from ITEM_DB */} {Number(selectedItem.DEF || selectedItem.defense) > 0 && (<li><b>DEF: </b>{selectedItem.DEF || selectedItem.defense}</li>)}
  {/* MATK --- from ITEM_DB */} {Number(selectedItem.MATK) > 0 && (<li><b>MATK: </b>{selectedItem.MATK}</li>)}
  {/* MDEF --- from ITEM_DB */} {Number(selectedItem.MDEF) > 0 && (<li><b>MDEF: </b>{selectedItem.MDEF}</li>)}

  {/* from ITEM_DESCRIPTION.JSON  */}
  {/* Weapon_lvl --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.weapon_level && (<li><b>{generalindex[currentLanguage].general.weapon_level}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.weapon_level}</li>)}
  {/* Property --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.element && (<li><b>{generalindex[currentLanguage].general.element}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.element}</li>)}
  {/* Equipped on --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.equipped_on && (<li><b>{generalindex[currentLanguage].general.equipped_on}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.equipped_on}</li>)}
  {/* Applicable_pet --- from "ITEM_DESCRIPTION.JSON" */} {currentEpisodeItemDescription[selectedItem.ID]?.applicable_pet && (<li><b>Pet: </b>{currentEpisodeItemDescription[selectedItem.ID]?.applicable_pet}</li>)}

  {/* STATS BLOCK --- from ITEM_DB  */}
  {selectedItem.STR > 0 && <li> STR+{selectedItem.STR}</li>}
  {selectedItem.AGI > 0 && <li> AGI+{selectedItem.AGI}</li>}
  {selectedItem.VIT > 0 && <li> VIT+{selectedItem.VIT}</li>}
  {selectedItem.INT > 0 && <li> INT+{selectedItem.INT}</li>}
  {selectedItem.DEX > 0 && <li> DEX+{selectedItem.DEX}</li>}
  {selectedItem.LUK > 0 && <li> LUK+{selectedItem.LUK}</li>}
  {selectedItem.CardHit > 0 && (<li> CardHit+{selectedItem.CardHit}</li>)}
  {selectedItem.CardCrit > 0 && (<li> CardCrit+{selectedItem.CardCrit}</li>)}
  {selectedItem.CardFlee > 0 && (<li> CardFlee+{selectedItem.CardFlee}</li>)}
  {selectedItem.CardSkill > 0 && (<li> CardSkill+{selectedItem.CardSkill}</li>)}


                </ul>
                  </div>

                  </div>{/* // ITEM DETAILS - TWO COLUMNS END */}

                  </div>{/* // ITEM DETAILS END */}

                </div>{/* // ITEM BODY END */}

                </div>{/* inner content wrapper */}
                </div>{/* // ITEM - RIGHT-TOP END */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ITEM - RIGHT-BOTTOM */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                <div style={{ display: "flex", flex: 1, overflow: "hidden", gap: IS_ALT ? "20px" : undefined }}>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ITEM - RIGHT-BOTTOM-LEFT */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                  <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ width: WIDTH_RIGHT_BOTTOM_LEFT, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                  {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Dropped By</div>}
                  <div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: IS_ALT ? 0 : "12px 20px" }}>

{/* // ITEM - DROPPED BY */}

                   <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid grey" }}>
                    {!IS_ALT && <caption className={`title-${currentEpisode} title-big`} style={{ captionSide: "top" }}>Dropped By</caption>}
                    <thead>
                      <tr style={{ borderBottom: "2px solid grey" }}>
                        <th style={{ textAlign: "center", padding: "0px 0px", width: "40px", borderRight: "1px solid grey" }}>Mob ID</th>
                        <th style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey", width: "20px" }}>Sprite</th>
                        <th style={{ textAlign: "left", padding: "0px 6px", whiteSpace: "nowrap", borderRight: "1px solid grey" }}>Monster Name</th>
                        <th style={{ textAlign: "center", padding: "0px 0px", width: "40px" }}>Drop Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                        {currentEpisodeDroppedBy[selectedItem.ID] && (
                            [...currentEpisodeDroppedBy[selectedItem.ID]].filter(e => e.rate > 0).filter(e => currentEpisodeMobSpawn.some(s => s.mob_id == e.mob_id)).sort((a, b) => b.rate - a.rate).filter((e, i, arr) => arr.findIndex(x => x.mob_id === e.mob_id) === i).map(droppedByEntry =>
                                <tr key={droppedByEntry.mob_id} className={`title-${currentEpisode} link`} onClick={() => makeDroppedByClickable(droppedByEntry.mob_id)} style={{ cursor: "pointer", borderBottom: "1px solid #ddd" }}>
                                  <td style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey" }}>{droppedByEntry.mob_id}</td>
                                  <td style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey" }}><img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/gifs/${droppedByEntry.mob_id}.gif`} alt="" style={{ maxWidth: "30px", maxHeight: "30px", verticalAlign: "middle" }} /></td>
                                  <td style={{ textAlign: "left", padding: "4px 6px", whiteSpace: "nowrap", borderRight: "1px solid grey" }}>{ index_mobs[droppedByEntry.mob_id] ? index_mobs[droppedByEntry.mob_id][currentLanguage] : droppedByEntry.mob_id }{mvps[droppedByEntry.mob_id] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/mvp.png" alt="MVP" style={{ maxHeight: "20px", marginLeft: "4px", verticalAlign: "middle" }} />}{minibosses[droppedByEntry.mob_id] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/miniboss.png" alt="Mini Boss" style={{ maxHeight: "20px", marginLeft: "4px", verticalAlign: "middle" }} />}<span style={{ opacity: 0.6 }}>{" "}- {droppedByEntry.mob_id}</span></td>
                                  <td style={{ textAlign: "center", padding: "4px 6px", whiteSpace: "nowrap" }}>{parseFloat((droppedByEntry.rate / 100 * dropRateMultiplier).toFixed(4)) > 100 ? 100 : parseFloat((droppedByEntry.rate / 100 * dropRateMultiplier).toFixed(4))}%</td>
                                </tr>
                              )
                        )}
                    </tbody>
                    </table>
                    {!currentEpisodeDroppedBy[selectedItem.ID] && "No monsters drop this item."}

                  </div>{/* inner content wrapper */}
                  </div>{/* // ITEM - RIGHT-BOTTOM-LEFT END */}

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ITEM - RIGHT-BOTTOM-MID */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                  <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ width: WIDTH_RIGHT_BOTTOM_MID, minWidth: 0, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                  {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Card Artwork</div>}
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, padding: IS_ALT ? 0 : "12px 20px" }}>

{/* // CARD ARTWORK */}
                    {!IS_ALT && cardImageExists && <div className={`title-${currentEpisode} title-big`}>Card Artwork</div>}
                    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 0 }}>
                      <img ref={cardImageRef} src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/cards/${selectedItem.ID}.png`} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} onLoad={(e) => setcardImageExists(e.target.naturalHeight > 0)} onError={() => setcardImageExists(false)} />
                    </div>

                  </div>{/* inner content wrapper */}
                  </div>{/* // ITEM - RIGHT-BOTTOM-MID END */}

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ITEM - RIGHT-BOTTOM-RIGHT */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                  <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ width: WIDTH_RIGHT_BOTTOM_RIGHT, minWidth: 0, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                  {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Where to Farm</div>}
                  <div style={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column", padding: IS_ALT ? 0 : "12px 20px" }}>

{/* // MAP TABS */}
                    {/* Item Maps (where mobs that drop this item spawn) */}
                    <ItemMapsTabs itemID={selectedItem.ID} currentEpisodeDroppedBy={currentEpisodeDroppedBy} currentEpisodeMobSpawn={currentEpisodeMobSpawn} activeItemMapTab={activeItemMapTab} setactiveItemMapTab={setactiveItemMapTab} currentEpisode={currentEpisode} currentLanguage={currentLanguage} onMobClick={makeDroppedByClickable} getMapUrl={getMapUrl} MENU_STYLE_CLASS={MENU_STYLE_CLASS}/>

                  </div>{/* inner content wrapper */}
                  </div>{/* // ITEM - RIGHT-BOTTOM-RIGHT END */}

                </div>{/* // ITEM - RIGHT-BOTTOM END */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
</div>
)}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // MOB DETAILS */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

              {selectedMob !== null && (
                <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden", gap: IS_ALT ? "20px" : undefined }}>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // MOB - RIGHT-TOP */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ flex: `0 0 ${HEIGHT_RIGHT_TOP}`, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Details</div>}
                <div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: IS_ALT ? "8px 0 0 8px" : "12px 20px" }}>

{/* // MOB BODY - two columns: (name + sprite) left, stat tables right aligned with the text top */}
                <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                  <div style={{ flexShrink: 0 }}>
{/* // MOB HEADER - Name + ID/AegisName (top left, sprite below) */}
                <div style={{ marginBottom: "10px" }}>
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>{ index_mobs[selectedMob.ID] ? index_mobs[selectedMob.ID][currentLanguage] : selectedMob.FriendlyName }{mvps[selectedMob.ID] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/mvp.png" alt="MVP" style={{ maxHeight: "40px", marginLeft: "4px", verticalAlign: "middle", marginTop: "-16px", marginBottom: "-10px" }} />}{minibosses[selectedMob.ID] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/miniboss.png" alt="Mini Boss" style={{ maxHeight: "40px", marginLeft: "4px", verticalAlign: "middle", marginTop: "-16px", marginBottom: "-10px" }} />}{((mvps[selectedMob.ID] && mvps[selectedMob.ID].type === "intance") || (minibosses[selectedMob.ID] && minibosses[selectedMob.ID].type === "intance")) && <span style={{ fontSize: "14px", opacity: 0.6, marginLeft: "6px", verticalAlign: "middle" }}>[Instance]</span>}</div>
                    <div style={{ fontSize: "11px", opacity: 0.7 }}>{selectedMob.ID} | {selectedMob.FriendlyName} | { index_mobs[selectedMob.ID] ? index_mobs[selectedMob.ID].AegisName : ""}</div>
                </div>

                  <div style={{ textAlign: "center" }}>
                    <div style={{ backgroundColor: "#e8e8e8", width: "140px", height: "140px", display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: "4px" }}>
                      <img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/gifs/${selectedMob.ID}.gif`} alt="" style={{ maxWidth: "140px", maxHeight: "140px" }} />
                    </div>
                  </div>
                  </div>{/* left column (name + sprite) end */}
                  <div style={{ marginTop: "9px" }}>{/* normal theme: tables dropped to the name's visual top line (name untouched) */}
                  <MobStatsTables selectedMob={selectedMob} currentLanguage={currentLanguage} currentEpisode={currentEpisode} baseExpMultiplier={baseExpMultiplier} jobExpMultiplier={jobExpMultiplier} />
                  </div>
                </div>{/* // MOB BODY END */}

                </div>{/* inner content wrapper */}
                </div>{/* // MOB - RIGHT-TOP END */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // MOB - RIGHT-BOTTOM */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                <div style={{ display: "flex", flex: 1, overflow: "hidden", gap: IS_ALT ? "20px" : undefined }}>
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // MOB - RIGHT-BOTTOM-LEFT */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                  <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ width: WIDTH_RIGHT_BOTTOM_LEFT, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                  {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Drop Table</div>}
                  <div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: IS_ALT ? 0 : "12px 20px" }}>

{/* // DROP LIST / Droptable */}
                   <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid grey" }}>
                    {!IS_ALT && <caption className={`title-${currentEpisode} title-big`} style={{ captionSide: "top" }}>Drop Table</caption>}
                    <thead>
                      <tr style={{ borderBottom: "2px solid grey" }}>
                        <th onClick={() => setdropTableSort(prev => ({ field: "slot", asc: prev.field === "slot" ? !prev.asc : true }))} style={{ textAlign: "center", padding: "0px 0px", width: "50px", borderRight: "1px solid grey", cursor: "pointer" }}>Drop Slot {dropTableSort.field === "slot" ? (dropTableSort.asc ? "\u25B2" : "\u25BC") : ""}</th>
                        <th style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey", width: "20px",  }}>Icon</th>
<th style={{ textAlign: "left", padding: "0px 6px", whiteSpace: "nowrap", borderRight: "1px solid grey" }}>Item Name</th>
                        <th onClick={() => setdropTableSort(prev => ({ field: "rate", asc: prev.field === "rate" ? !prev.asc : false }))} style={{ textAlign: "center", padding: "0px 0px", width: "40px", cursor: "pointer" }}>Drop Rate {dropTableSort.field === "rate" ? (dropTableSort.asc ? "\u25B2" : "\u25BC") : ""}</th>
                      </tr>
                    </thead>
                    <tbody>
{/* // Build sortable drop entries array */}
                    {(() => {
                      const getItemSlots = (itemId) => { const item = currentEpisodeItemDB.find(i => i.ID == itemId); return item ? (item.Slots || item.SLOT || item.Slot || 0) : 0; };
                      const regularEntries = [];
                      const mvpEntries = [];
                      DROP_SLOTS_ARRAY.forEach((dropSlot) => {
                        if (selectedMob[`Drop${dropSlot}`] > 0 && !(selectedMob[`Drop${dropSlot}`] == 512 && selectedMob[`Rate${dropSlot}`] == 0)) {
                          regularEntries.push({ slotNumber: dropSlot, dropID: selectedMob[`Drop${dropSlot}`], baseDropRate: selectedMob[`Rate${dropSlot}`], isMvp: false, sortSlot: dropSlot });
                        }
                      });
                      MVP_DROP_SLOTS_ARRAY.forEach((mvpSlot) => {
                        if (selectedMob[`MvpDrop${mvpSlot}`] > 0 && !(selectedMob[`MvpDrop${mvpSlot}`] == 512 && selectedMob[`MvpRate${mvpSlot}`] == 0)) {
                          mvpEntries.push({ slotNumber: "MVP", dropID: selectedMob[`MvpDrop${mvpSlot}`], baseDropRate: selectedMob[`MvpRate${mvpSlot}`], isMvp: true, sortSlot: 10 + mvpSlot });
                        }
                      });
                      if (dropTableSort.field === "rate") {
                        regularEntries.sort((a, b) => dropTableSort.asc ? a.baseDropRate - b.baseDropRate : b.baseDropRate - a.baseDropRate);
                      } else {
                        regularEntries.sort((a, b) => dropTableSort.asc ? a.sortSlot - b.sortSlot : b.sortSlot - a.sortSlot);
                      }
                      return [...regularEntries, ...mvpEntries].map((entry) => (
                          <DropEntry
                            key={entry.isMvp ? `mvp${entry.sortSlot - 10}` : entry.slotNumber}
                            slotNumber={entry.slotNumber}
                            dropID={entry.dropID}
                            dropRateMultiplier={dropRateMultiplier}
                            baseDropRate={entry.baseDropRate}
                            makeDropClickable={makeDropClickable}
                            itemIndex={index_items}
                            currentEpisode={currentEpisode}
                            currentLanguage={currentLanguage}
                            isMvp={entry.isMvp}
                            itemSlots={getItemSlots(entry.dropID)}
                          />
                      ));
                    })()}
                    </tbody>
                    </table>

                  </div>{/* inner content wrapper */}
                  </div>{/* // MOB - RIGHT-BOTTOM-LEFT END */}

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // MOB - RIGHT-BOTTOM-MID */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                  <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ width: WIDTH_RIGHT_BOTTOM_MID, minWidth: 0, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                  {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}></div>}
                  <div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: IS_ALT ? 0 : "12px 20px" }}>

{/* // ELEMENTAL DAMAGE (moved from RIGHT-TOP) + WEAPON DAMAGE PER SIZE */}
                    <div className={`title-${currentEpisode} title-big`}>Elemental Damage</div>
                    <ElementDamageTable selectedMob={selectedMob} currentLanguage={currentLanguage} />
                    <div className={`title-${currentEpisode} title-big`} style={{ marginTop: "14px" }}>Weapon Damage by Size</div>
                    <WpnDmgPerSizeTable selectedMob={selectedMob} currentEpisode={currentEpisode} />

                  </div>{/* inner content wrapper */}
                  </div>{/* // MOB - RIGHT-BOTTOM-MID END */}

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // MOB - RIGHT-BOTTOM-RIGHT */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
                  <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ width: WIDTH_RIGHT_BOTTOM_RIGHT, minWidth: 0, padding: 0, border: IS_ALT ? "1px solid #8596c9" : "1px solid grey", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                  {IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Spawn Maps</div>}
                  <div style={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column", padding: IS_ALT ? 0 : "12px 20px" }}>

{/* // MAP TABS */}
                    {/* New Spawn List (Tabs) */}
                    <SpawnMapsTabs ID={selectedMob.ID} currentEpisodeMobSpawn={currentEpisodeMobSpawn} activeSpawnTab={activeSpawnTab} setactiveSpawnTab={setactiveSpawnTab} currentEpisode={currentEpisode} currentLanguage={currentLanguage} onMobClick={makeDroppedByClickable} getMapUrl={getMapUrl} MENU_STYLE_CLASS={MENU_STYLE_CLASS}/>
                    {/* Old Spawn List */}
                    {/* <SpawnMaps ID={selectedMob.ID}/> */}

                  </div>{/* inner content wrapper */}
                  </div>{/* // MOB - RIGHT-BOTTOM-RIGHT END */}

                </div>{/* // MOB - RIGHT-BOTTOM END */}


                </div>
              )}
</>}{/* // NON-ALT END */}
{/* // MOB DETAIL ENDS */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ALT MODE: Persistent window layout */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

{IS_ALT && selectedPage === null && selectedEpisodeDetails === null && ( /* Database view only: site pages and Episode Details get their own RO window below */
<div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden", gap: "20px" }}>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ALT - RIGHT-TOP (Details) */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
<div className={`background-${currentEpisode}`} style={{ flex: `0 0 ${HEIGHT_RIGHT_TOP}`, padding: 0, border: "1px solid #8596c9", overflow: "hidden", display: "flex", flexDirection: "column" }}>
<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Details</div>
<div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: "11px 0 0 8px" }}>{/* top gap tuned to visually match the left gap (photo to window edge) */}

{selectedItem !== null && (<>
{/* // ITEM HEADER - Icon + Name + ID */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                  <div style={{ backgroundColor: "#e8e8e8", padding: "6px", display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: "4px" }}><img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/icons/${selectedItem.ID}.png`} alt="" /></div>
                  <div>
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>{ index_items[selectedItem.ID] ? index_items[selectedItem.ID][currentLanguage] : (selectedItem.FriendlyName || selectedItem.ShortName || selectedItem.NAME) } {Number(selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot) > 0 && `[${selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot}]`}</div>
                    <div style={{ fontSize: "11px", opacity: 0.7 }}>{selectedItem.ID} | {selectedItem.ShortName || selectedItem.FriendlyName || selectedItem.NAME} | { index_items[selectedItem.ID] ? index_items[selectedItem.ID].AegisName : ""}</div>
                  </div>
                </div>
{/* // ITEM BODY - Image left, Details right */}
                <div style={{ display: "flex", gap: "12px" }}>
                  <div style={{ flexShrink: 0, display: "flex", gap: "12px" }}>
                    <div style={{ textAlign: "center" }}>
                      <img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/images/${selectedItem.ID}.png`} alt="" />
                      <div style={{ fontSize: "10px", opacity: 0.7 }}>New Image</div>
                    </div>
                    {oldImageExists && <div style={{ textAlign: "center" }}>
                      <img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/images-old/${selectedItem.ID}.png`} alt=""
                        onError={() => setoldImageExists(false)}
                      />
                      <div style={{ fontSize: "10px", opacity: 0.7 }}>Old Image</div>
                    </div>}
                  </div>
                  <div>
  {currentEpisodeItemDescription[selectedItem.ID]?.description && (<div style={{ marginBottom: "8px" }}>{currentEpisodeItemDescription[selectedItem.ID]?.description}</div>)}
                  <div style={{ display: "flex", gap: "20px" }}>
                  <div>
                <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
  {currentEpisodeItemDescription[selectedItem.ID]?.item_class && (<li><b>{generalindex[currentLanguage].general.item_class}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.item_class}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.compound_on && (<li><b>{generalindex[currentLanguage].general.compound_on || "Compound on"}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.compound_on}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.defense && (<li><b>{generalindex[currentLanguage].general.defense}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.defense}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.weight && (<li><b>{generalindex[currentLanguage].general.weight}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.weight}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.level_required && (<li><b>{generalindex[currentLanguage].general.level_required}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.level_required}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.applicable_jobs && (<li><b>{generalindex[currentLanguage].general.applicable_jobs}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.applicable_jobs}</li>)}
                </ul>
                  </div>
                  <div>
                <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
  <li><b>{generalindex[currentLanguage].general.npc_price || "Buy At"}: </b>{selectedItem.NPCPrice || selectedItem.Price || selectedItem.PRICE}z</li>
  <li><b>{generalindex[currentLanguage].general.sell_at || "Sell At"}: </b>{(selectedItem.NPCPrice || selectedItem.Price || selectedItem.PRICE) / 2}z</li>
  {Number(selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot) > 0 && (<li><b>Slots: </b>{selectedItem.Slots || selectedItem.SLOT || selectedItem.Slot}</li>)}
  {Number(selectedItem.MinLvl || selectedItem.equipableLevel || selectedItem.level_required || selectedItem.eLV) > 0 && (<li><b>{generalindex[currentLanguage].general.level_required || "Level Required"}: </b>{selectedItem.MinLvl || selectedItem.equipableLevel || selectedItem.level_required || selectedItem.eLV}</li>)}
  {Number(selectedItem.ATK || selectedItem.weapon_attack) > 0 && (<li><b>ATK: </b>{selectedItem.ATK || selectedItem.weapon_attack}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.weapon_attack && (<li><b>{generalindex[currentLanguage].general.weapon_attack}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.weapon_attack}</li>)}
  {Number(selectedItem.DEF || selectedItem.defense) > 0 && (<li><b>DEF: </b>{selectedItem.DEF || selectedItem.defense}</li>)}
  {Number(selectedItem.MATK) > 0 && (<li><b>MATK: </b>{selectedItem.MATK}</li>)}
  {Number(selectedItem.MDEF) > 0 && (<li><b>MDEF: </b>{selectedItem.MDEF}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.weapon_level && (<li><b>{generalindex[currentLanguage].general.weapon_level}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.weapon_level}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.element && (<li><b>{generalindex[currentLanguage].general.element}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.element}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.equipped_on && (<li><b>{generalindex[currentLanguage].general.equipped_on}: </b>{currentEpisodeItemDescription[selectedItem.ID]?.equipped_on}</li>)}
  {currentEpisodeItemDescription[selectedItem.ID]?.applicable_pet && (<li><b>Pet: </b>{currentEpisodeItemDescription[selectedItem.ID]?.applicable_pet}</li>)}
  {selectedItem.STR > 0 && <li> STR+{selectedItem.STR}</li>}
  {selectedItem.AGI > 0 && <li> AGI+{selectedItem.AGI}</li>}
  {selectedItem.VIT > 0 && <li> VIT+{selectedItem.VIT}</li>}
  {selectedItem.INT > 0 && <li> INT+{selectedItem.INT}</li>}
  {selectedItem.DEX > 0 && <li> DEX+{selectedItem.DEX}</li>}
  {selectedItem.LUK > 0 && <li> LUK+{selectedItem.LUK}</li>}
  {selectedItem.CardHit > 0 && (<li> CardHit+{selectedItem.CardHit}</li>)}
  {selectedItem.CardCrit > 0 && (<li> CardCrit+{selectedItem.CardCrit}</li>)}
  {selectedItem.CardFlee > 0 && (<li> CardFlee+{selectedItem.CardFlee}</li>)}
  {selectedItem.CardSkill > 0 && (<li> CardSkill+{selectedItem.CardSkill}</li>)}
                </ul>
                  </div>
                  </div>
                  </div>
                </div>
</>)}

{selectedMob !== null && (<>
{/* // MOB BODY - two columns: (name + sprite) left, stat tables right. RO theme: name+sprite raised to match the tables' top */}
                <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                  <div style={{ flexShrink: 0, marginTop: "-9px" }}>
{/* // MOB HEADER - Name + ID/AegisName (top left, sprite below) */}
                <div style={{ marginBottom: "10px" }}>
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>{ index_mobs[selectedMob.ID] ? index_mobs[selectedMob.ID][currentLanguage] : selectedMob.FriendlyName }{mvps[selectedMob.ID] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/mvp.png" alt="MVP" style={{ maxHeight: "40px", marginLeft: "4px", verticalAlign: "middle", marginTop: "-16px", marginBottom: "-10px" }} />}{minibosses[selectedMob.ID] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/miniboss.png" alt="Mini Boss" style={{ maxHeight: "40px", marginLeft: "4px", verticalAlign: "middle", marginTop: "-16px", marginBottom: "-10px" }} />}{((mvps[selectedMob.ID] && mvps[selectedMob.ID].type === "intance") || (minibosses[selectedMob.ID] && minibosses[selectedMob.ID].type === "intance")) && <span style={{ fontSize: "14px", opacity: 0.6, marginLeft: "6px", verticalAlign: "middle" }}>[Instance]</span>}</div>
                    <div style={{ fontSize: "11px", opacity: 0.7 }}>{selectedMob.ID} | {selectedMob.FriendlyName} | { index_mobs[selectedMob.ID] ? index_mobs[selectedMob.ID].AegisName : ""}</div>
                </div>

                  <div style={{ textAlign: "center" }}>
                    <div style={{ backgroundColor: "#e8e8e8", width: "140px", height: "140px", display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: "4px" }}>
                      <img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/gifs/${selectedMob.ID}.gif`} alt="" style={{ maxWidth: "140px", maxHeight: "140px" }} />
                    </div>
                  </div>
                  </div>{/* left column (name + sprite) end */}
                  <MobStatsTables selectedMob={selectedMob} currentLanguage={currentLanguage} currentEpisode={currentEpisode} baseExpMultiplier={baseExpMultiplier} jobExpMultiplier={jobExpMultiplier} />
                </div>
</>)}

</div>{/* inner content wrapper */}
</div>{/* // ALT - RIGHT-TOP END */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ALT - RIGHT-BOTTOM */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
<div style={{ display: "flex", flex: 1, overflow: "hidden", gap: "20px" }}>

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ALT - RIGHT-BOTTOM-LEFT (Dropped By / Drop Table) */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
<div className={`background-${currentEpisode}`} style={{ width: WIDTH_RIGHT_BOTTOM_LEFT, padding: 0, border: "1px solid #8596c9", overflow: "hidden", display: "flex", flexDirection: "column" }}>
<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>{selectedItem !== null ? "Dropped By" : "Drop Table"}</div>
<div style={{ overflow: "auto", flex: 1, minHeight: 0 }}>

{selectedItem !== null && (<>
                   <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid grey" }}>
                    <thead>
                      <tr style={{ borderBottom: "2px solid grey" }}>
                        <th style={{ textAlign: "center", padding: "0px 0px", width: "40px", borderRight: "1px solid grey" }}>Mob ID</th>
                        <th style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey", width: "20px" }}>Sprite</th>
                        <th style={{ textAlign: "left", padding: "0px 6px", whiteSpace: "nowrap", borderRight: "1px solid grey" }}>Monster Name</th>
                        <th style={{ textAlign: "center", padding: "0px 0px", width: "40px" }}>Drop Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                        {currentEpisodeDroppedBy[selectedItem.ID] && (
                            [...currentEpisodeDroppedBy[selectedItem.ID]].filter(e => e.rate > 0).filter(e => currentEpisodeMobSpawn.some(s => s.mob_id == e.mob_id)).sort((a, b) => b.rate - a.rate).filter((e, i, arr) => arr.findIndex(x => x.mob_id === e.mob_id) === i).map(droppedByEntry =>
                                <tr key={droppedByEntry.mob_id} className={`title-${currentEpisode} link`} onClick={() => makeDroppedByClickable(droppedByEntry.mob_id)} style={{ cursor: "pointer", borderBottom: "1px solid #ddd" }}>
                                  <td style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey" }}>{droppedByEntry.mob_id}</td>
                                  <td style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey" }}><img src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/gifs/${droppedByEntry.mob_id}.gif`} alt="" style={{ maxWidth: "30px", maxHeight: "30px", verticalAlign: "middle" }} /></td>
                                  <td style={{ textAlign: "left", padding: "4px 6px", whiteSpace: "nowrap", borderRight: "1px solid grey" }}>{ index_mobs[droppedByEntry.mob_id] ? index_mobs[droppedByEntry.mob_id][currentLanguage] : droppedByEntry.mob_id }{mvps[droppedByEntry.mob_id] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/mvp.png" alt="MVP" style={{ maxHeight: "20px", marginLeft: "4px", verticalAlign: "middle" }} />}{minibosses[droppedByEntry.mob_id] && <img src="https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/other/miniboss.png" alt="Mini Boss" style={{ maxHeight: "20px", marginLeft: "4px", verticalAlign: "middle" }} />}<span style={{ opacity: 0.6 }}>{" "}- {droppedByEntry.mob_id}</span></td>
                                  <td style={{ textAlign: "center", padding: "4px 6px", whiteSpace: "nowrap" }}>{parseFloat((droppedByEntry.rate / 100 * dropRateMultiplier).toFixed(4)) > 100 ? 100 : parseFloat((droppedByEntry.rate / 100 * dropRateMultiplier).toFixed(4))}%</td>
                                </tr>
                              )
                        )}
                    </tbody>
                    </table>
                    {!currentEpisodeDroppedBy[selectedItem.ID] && "No monsters drop this item."}
</>)}

{selectedMob !== null && (<>
                   <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid grey" }}>
                    <thead>
                      <tr style={{ borderBottom: "2px solid grey" }}>
                        <th onClick={() => setdropTableSort(prev => ({ field: "slot", asc: prev.field === "slot" ? !prev.asc : true }))} style={{ textAlign: "center", padding: "0px 0px", width: "50px", borderRight: "1px solid grey", cursor: "pointer" }}>Drop Slot {dropTableSort.field === "slot" ? (dropTableSort.asc ? "\u25B2" : "\u25BC") : ""}</th>
                        <th style={{ textAlign: "center", padding: "4px 6px", borderRight: "1px solid grey", width: "20px",  }}>Icon</th>
<th style={{ textAlign: "left", padding: "0px 6px", whiteSpace: "nowrap", borderRight: "1px solid grey" }}>Item Name</th>
                        <th onClick={() => setdropTableSort(prev => ({ field: "rate", asc: prev.field === "rate" ? !prev.asc : false }))} style={{ textAlign: "center", padding: "0px 0px", width: "40px", cursor: "pointer" }}>Drop Rate {dropTableSort.field === "rate" ? (dropTableSort.asc ? "\u25B2" : "\u25BC") : ""}</th>
                      </tr>
                    </thead>
                    <tbody>
                    {(() => {
                      const getItemSlots = (itemId) => { const item = currentEpisodeItemDB.find(i => i.ID == itemId); return item ? (item.Slots || item.SLOT || item.Slot || 0) : 0; };
                      const regularEntries = [];
                      const mvpEntries = [];
                      DROP_SLOTS_ARRAY.forEach((dropSlot) => {
                        if (selectedMob[`Drop${dropSlot}`] > 0 && !(selectedMob[`Drop${dropSlot}`] == 512 && selectedMob[`Rate${dropSlot}`] == 0)) {
                          regularEntries.push({ slotNumber: dropSlot, dropID: selectedMob[`Drop${dropSlot}`], baseDropRate: selectedMob[`Rate${dropSlot}`], isMvp: false, sortSlot: dropSlot });
                        }
                      });
                      MVP_DROP_SLOTS_ARRAY.forEach((mvpSlot) => {
                        if (selectedMob[`MvpDrop${mvpSlot}`] > 0 && !(selectedMob[`MvpDrop${mvpSlot}`] == 512 && selectedMob[`MvpRate${mvpSlot}`] == 0)) {
                          mvpEntries.push({ slotNumber: "MVP", dropID: selectedMob[`MvpDrop${mvpSlot}`], baseDropRate: selectedMob[`MvpRate${mvpSlot}`], isMvp: true, sortSlot: 10 + mvpSlot });
                        }
                      });
                      if (dropTableSort.field === "rate") {
                        regularEntries.sort((a, b) => dropTableSort.asc ? a.baseDropRate - b.baseDropRate : b.baseDropRate - a.baseDropRate);
                      } else {
                        regularEntries.sort((a, b) => dropTableSort.asc ? a.sortSlot - b.sortSlot : b.sortSlot - a.sortSlot);
                      }
                      return [...regularEntries, ...mvpEntries].map((entry) => (
                          <DropEntry
                            key={entry.isMvp ? `mvp${entry.sortSlot - 10}` : entry.slotNumber}
                            slotNumber={entry.slotNumber}
                            dropID={entry.dropID}
                            dropRateMultiplier={dropRateMultiplier}
                            baseDropRate={entry.baseDropRate}
                            makeDropClickable={makeDropClickable}
                            itemIndex={index_items}
                            currentEpisode={currentEpisode}
                            currentLanguage={currentLanguage}
                            isMvp={entry.isMvp}
                            itemSlots={getItemSlots(entry.dropID)}
                          />
                      ));
                    })()}
                    </tbody>
                    </table>
</>)}

</div>{/* inner content wrapper */}
</div>{/* // ALT - RIGHT-BOTTOM-LEFT END */}

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ALT - RIGHT-BOTTOM-MID */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
<div className={`background-${currentEpisode}`} style={{ width: WIDTH_RIGHT_BOTTOM_MID, minWidth: 0, padding: 0, border: "1px solid #8596c9", overflow: "hidden", display: "flex", flexDirection: "column" }}>
<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>{selectedItem !== null ? "Card Artwork" : selectedMob !== null ? "Elemental / Weapon Damage" : ""}</div>
<div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>

{selectedItem !== null && (
                    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 0 }}>
                      <img ref={cardImageRef} src={`https://vitcunha.s3.sa-east-1.amazonaws.com/ragnadb/cards/${selectedItem.ID}.png`} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} onLoad={(e) => setcardImageExists(e.target.naturalHeight > 0)} onError={() => setcardImageExists(false)} />
                    </div>
)}

{selectedMob !== null && (
                    <div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: "8px" }}>
                      <ElementDamageTable selectedMob={selectedMob} currentLanguage={currentLanguage} />
                      <div className={`title-${currentEpisode} title-big`} style={{ marginTop: "14px" }}>Weapon Damage by Size</div>
                      <WpnDmgPerSizeTable selectedMob={selectedMob} currentEpisode={currentEpisode} />
                    </div>
)}

</div>{/* inner content wrapper */}
</div>{/* // ALT - RIGHT-BOTTOM-MID END */}

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // ALT - RIGHT-BOTTOM-RIGHT */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
<div className={`background-${currentEpisode}`} style={{ width: WIDTH_RIGHT_BOTTOM_RIGHT, minWidth: 0, padding: 0, border: "1px solid #8596c9", overflow: "hidden", display: "flex", flexDirection: "column" }}>
<div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>{selectedItem !== null ? "Where to Farm" : selectedMob !== null ? "Spawn Maps" : ""}</div>
<div style={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>

{selectedItem !== null && <ItemMapsTabs itemID={selectedItem.ID} currentEpisodeDroppedBy={currentEpisodeDroppedBy} currentEpisodeMobSpawn={currentEpisodeMobSpawn} activeItemMapTab={activeItemMapTab} setactiveItemMapTab={setactiveItemMapTab} currentEpisode={currentEpisode} currentLanguage={currentLanguage} onMobClick={makeDroppedByClickable} getMapUrl={getMapUrl} MENU_STYLE_CLASS={MENU_STYLE_CLASS}/>}
{selectedMob !== null && <SpawnMapsTabs ID={selectedMob.ID} currentEpisodeMobSpawn={currentEpisodeMobSpawn} activeSpawnTab={activeSpawnTab} setactiveSpawnTab={setactiveSpawnTab} currentEpisode={currentEpisode} currentLanguage={currentLanguage} onMobClick={makeDroppedByClickable} getMapUrl={getMapUrl} MENU_STYLE_CLASS={MENU_STYLE_CLASS}/>}

</div>{/* inner content wrapper */}
</div>{/* // ALT - RIGHT-BOTTOM-RIGHT END */}

</div>{/* // ALT - RIGHT-BOTTOM END */}

</div>
)}{/* // ALT DETAIL ENDS */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // EPISODE DETAILS */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}


{/* 
{selectedEpisodeDetails !== null && 
              <div>
                    {selectedEpisodeDetails === "00" ? (
                      <p>alpha</p>
                    ) : selectedEpisodeDetails === "default" ? (
                      <p>default</p>
                    ) : (
                      <p>No matching episode</p>
                    )}
              </div>
}
*/}

{selectedEpisodeDetails !== null && (
<div className={IS_ALT ? `background-${currentEpisode}` : ""} style={{ flex: 1, minHeight: 0, padding: 0, border: IS_ALT ? "1px solid #8596c9" : undefined, overflow: "hidden", display: "flex", flexDirection: "column" }}>{/* RO Theme: same window shell as the database windows */}
{IS_ALT && <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>Episode Details</div>}
<div style={{ overflow: "auto", flex: 1, minHeight: 0, padding: IS_ALT ? "8px 12px 12px 8px" : "12px 20px" }}>
{!IS_ALT && <div className={`title-${currentEpisode} title-big`}>Episode Details</div>}
<EpisodeDetailsView
  currentEpisode={currentEpisode}
  currentLanguage={currentLanguage}
  availableEpisodes={AVAILABLE_EPISODES}
  currentEpisodeMobDB={currentEpisodeMobDB}
  currentEpisodeItemDB={currentEpisodeItemDB}
  currentEpisodeMobSpawn={currentEpisodeMobSpawn}
  currentEpisodeDroppedBy={currentEpisodeDroppedBy}
  hideNoSpawn={hideNoSpawn} sethideNoSpawn={sethideNoSpawn}
  hideNoDrop={hideNoDrop} sethideNoDrop={sethideNoDrop}
  onMobClick={(id) => { setselectedEpisodeDetails(null); makeDroppedByClickable(id); }}
  onItemClick={(id) => { setselectedEpisodeDetails(null); makeDropClickable(id); }}
/>
</div>
</div>
)}

{/* // EPISODE DETAIL ENDS */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // SITE PAGES - ABOUT / TIMELINE */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}


{selectedPage === "about" && (
              <div className={IS_ALT ? `background-${currentEpisode}` : ""} style={IS_ALT ? { flex: 1, minHeight: 0, padding: 0, border: "1px solid #8596c9", overflow: "hidden", display: "flex", flexDirection: "column" } : { padding: "0px 20px 20px 20px" }}>{/* RO Theme: same window shell as the database windows */}
                    <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={IS_ALT ? { marginTop: 0 } : undefined}>About the project</div>
                    <div style={IS_ALT ? { overflow: "auto", flex: 1, minHeight: 0, padding: "8px 20px 20px 8px" } : undefined}>
                    <p>RagnaDB is a time-travelling database for classic Ragnarok Online — browse items, monsters, drops and spawns exactly as they were in each episode.</p>
                    </div>
              </div>
)}

{selectedPage === "timeline" && (
              <TimelineView />
)}

{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // WORLD MAP */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}

{selectedPage === "worldmap" && IS_ALT && (
              <div className={`background-${currentEpisode}`} style={{ flex: 1, minHeight: 0, padding: 0, border: "1px solid #8596c9", overflow: "hidden", display: "flex", flexDirection: "column" }}>{/* RO Theme: same window shell as the database windows */}
              <div className={`title-${currentEpisode} ${MENU_STYLE_CLASS}`} style={{ marginTop: 0 }}>World Map</div>
              <WorldMapView
                currentEpisode={currentEpisode}
                currentLanguage={currentLanguage}
                currentEpisodeMobSpawn={currentEpisodeMobSpawn}
                getMapUrl={getMapUrl}
                onMobClick={(mobId) => { setselectedPage(null); makeDroppedByClickable(mobId); }}
              />
              </div>
)}
{selectedPage === "worldmap" && !IS_ALT && (
              <WorldMapView
                currentEpisode={currentEpisode}
                currentLanguage={currentLanguage}
                currentEpisodeMobSpawn={currentEpisodeMobSpawn}
                getMapUrl={getMapUrl}
                onMobClick={(mobId) => { setselectedPage(null); makeDroppedByClickable(mobId); }}
              />
)}

{/* // SITE PAGES END */}

            </div>
          </div>
        </div>
      </div>
    </div>  {/* // TOP + LEFT + RIGHT CONTAINER END */}


{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}
{/* // FOOTER */}
{/*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*/}


<div style={{ position: "fixed", bottom: "8px", right: "8px", fontSize: "10px", color: "white", fontFamily: "OCRAStd", textAlign: "right", lineHeight: "1-4", zIndex: 9998, pointerEvents: "auto" }}>
  <span>Made with <span style={{ color: "#e25555", fontSize:"14px" }}>❤</span> by vitcunha & oldinroplayer</span><br />
  <a href="https://discord.gg/Cpe6rMN2UR" target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "underline" }}>Join our Discord</a> | <a href="https://ko-fi.com/vitcunha" target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "underline" }}>Buy us a coffee</a>
</div>


    </div>  /* WRAPPER DIV END */
  
  ); {/* // APP RETURN ENDS */}

} {/* // APP FUNCTION */}
